<template>
  <div class="mt-0">
    <div class="go-top" @click="goToTop()">
      <v-icon>mdi-arrow-up</v-icon>
    </div>
    <PickPackage
      :pickPackage="pickPackage"
      @closePickPackage="closePickPackage"
      @deleteProfileModal="deleteProfileModal"
      :personData="personData"
      :personMetrics="personMetrics"
    />

    <OrderDigitalGifts
      :dialog="dialogShowOrderDigitalGifts"
      @close="closeDialogShowOrderDigitalGifts"
    />

    <DeleteProfileDialog
      :showDeleteProfileDialog="showDeleteProfileDialog"
      @closeDeleteProfileDialog="closeDeleteProfileDialog"
      @deleteProfile="deleteProfile"
    />

    <DeleteItemModal
      :deleteDialog="deleteDialog"
      :suggestedActionType="suggestedActionType"
      @closeDeleteItemDialog="closeDeleteItemDialog"
      @deleteItem="deleteItem"
    />
    <SuggestedImagesConfirmDialogModal
      :pickedImages="pickedImages"
      :suggestedImagesConfirmDialog="suggestedImagesConfirmDialog"
      :suggestedActionType="suggestedActionType"
      @closeSuggestedImagesConfirmDialog="closeSuggestedImagesConfirmDialog"
      @acceptSuggestedImages="acceptSuggestedImages"
      @deleteSuggestedImages="deleteSuggestedImages"
    />
    <ShowShareSocialActionsPopup
      @closeShareSocialActionsPopup="closeShareSocialActionsPopup"
      :showShareSocialActionsPopup="showShareSocialActionsPopup"
      :networks="networks"
      :sharing="sharing"
    />
    <LikesDialog :likeList="likeList" @closeLikeList="closeLikeList" />
    <FollowersDialog
      :followerList="followerList"
      @closeFollowerList="closeFollowerList"
      :dialogFollowers="dialogFollowers"
    />
    <ShowQrCodeDialog
      :qrCodeValue="qrCodeValue"
      :personMetrics="personMetrics"
      :showQrCodePopup="showQrCodePopup"
      @closeQrCodePopup="closeQrCodePopup"
      @downloadQrCode="downloadQrCode"
    />
    <DeleteCommentDialog
      :commentForDelete="commentForDelete"
      :openDeleteCommentModel="openDeleteCommentModel"
      @closeDeleteCommentModel="closeDeleteCommentModel"
      @deleteComment="deleteComment"
    />
    <FollowDialog
      :dialogFollow="dialogFollow"
      :personMetrics="personMetrics"
      @closeDialogFollowPerson="closeDialogFollowPerson"
      @followPerson="followPerson"
    />
    <DeleteLastGreetingsDialog
      :openDeleteGreetingModel="openDeleteGreetingModel"
      @deleteLastGreeting="deleteLastGreeting"
      @closeLastGreetingsDialog="closeLastGreetingsDialog"
      :currentGreeting="currentGreeting"
    />
    <ReportGreetingDialog
      :openReportGreetingModel="openReportGreetingModel"
      @reportLastGreeting="reportLastGreeting"
      @closeLastGreetingReport="closeLastGreetingReport"
      :currentGreeting="currentGreeting"
    />
    <ReportProfileDialog
      :openReportProfileModel="openReportProfileModel"
      @reportProfile="reportProfile"
      @closeReportProfile="closeReportProfile"
    />
    <ReportImageDialog
      :openReportImageModel="openReportImageModel"
      @reportImage="reportImage"
      @closeReportImage="closeReportImage"
    />
    <ReportVideoDialog
      :openReportVideoModel="openReportVideoModel"
      @reportVideo="reportVideo"
      @closeReportVideo="closeReportVideo"
    />
    <ReportCommentDialog
      :openReportCommentModel="openReportCommentModel"
      @reportComment="reportComment"
      @closeReportComment="closeReportComment"
    />
    <ReportCommentThreadDialog
      :openReportCommentThreadModel="openReportCommentThreadModel"
      @reportCommentThread="reportCommentThread"
      @closeReportCommentThread="closeReportCommentThread"
    />
    <v-dialog
      v-model="dialogInvite"
      class="rounded-xl"
      persistent
      max-width="800px"
    >
      <v-card
        style="
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
          border-radius: 12px;
        "
      >
        <v-card-title class="px-3">
          <span class="gc-text-h6">{{ lang.profile.w1 }}</span>
        </v-card-title>
        <v-card-text class="pb-0 mb-0 px-3">
          <v-form ref="dialogInviteForm" @submit.prevent="addInviteMails()">
            <div class="d-flex align-end mb-2">
              <div class="input-group mr-2" style="width: 100%">
                <label>{{ lang.fields.mail }} *</label>
                <input
                  type="text"
                  v-model="inviteEmail"
                  @keydown.enter="addInviteMails()"
                />
              </div>
              <v-btn
                class="btn-bg mt-4 mb-2"
                elevation="0"
                small
                @click="addInviteMails()"
                >{{ lang.actions.add }}</v-btn
              >
            </div>
            <div class="mb-4">
              <v-chip
                small
                class="mb-2 mr-2"
                v-for="(item, index) in inviteEmails"
                :key="index"
                close
                @click:close="inviteEmails.splice(index, 1)"
              >
                {{ item }}
              </v-chip>
            </div>
            <div class="input-group mb-4">
              <label>{{ lang.fields.description }} *</label>
              <textarea v-model="inviteDescription" rows="4"></textarea>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            small
            text
            @click="closeDialogInvite()"
            elevation="0"
          >
            {{ lang.actions.close }}
          </v-btn>
          <v-btn
            small
            class="btn-bg"
            elevation="0"
            @click="inviteUser()"
            v-if="personData.userId == currentUser.id"
          >
            {{ lang.actions.invite }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-row class="no-gutters mt-0" v-if="currentPersonImage">
          <v-col
            class="col-12 image-container"
            :class="{ 'col-md-9': showImageAndVideoComments }"
          >
            <v-icon @click="closeImageDialog()" class="close-dialog"
              >mdi-close</v-icon
            >
            <div
              class="action-dialog d-flex flex-column align-center"
              v-if="
                personData &&
                personData.images &&
                personData.images[imageShowIndex]
              "
            >
              <div class="show-info-relative">
                <v-icon
                  v-if="showImageAndVideoInfo"
                  @click="showInfoContainer(currentPersonImage, 'Image')"
                  class="mr-1 cursor-pointer display-1 mb-1 white--text"
                  >mdi-information-outline</v-icon
                >
                <div class="show-info-container" v-if="showInfo">
                  <v-card class="px-4 no-shadow">
                    <v-row id="mt-0" class="mt-0" v-if="currentPersonImage">
                      <v-icon
                        v-if="
                          !showInfoEdit && personData.userId == currentUser.id
                        "
                        @click="editInfo(currentPersonImage, 'image')"
                        class="edit-dialog-info"
                        small
                        style="width: 20px; height: 20px"
                        >mdi-pencil</v-icon
                      >
                      <v-icon
                        small
                        style="width: 20px; height: 20px"
                        @click="closeInfoDialog()"
                        class="close-dialog-info"
                        >mdi-close</v-icon
                      >
                      <v-col cols="12" class="mt-10 px-1" v-if="showInfoEdit">
                        <v-text-field
                          v-model="info.location"
                          :label="lang.fields.location"
                          hide-details
                          outlined
                          dense
                          @keydown.enter="saveInfo(saveInfo)"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="mt-10 px-1" v-else>
                        <p class="info-title body-2 font-weight-bold mb-0">
                          {{ lang.fields.location }}
                        </p>
                        <p class="info-text body-2 mb-0">
                          <v-icon class="caption">mdi-google-maps</v-icon>
                          {{
                            currentPersonImage.location || lang.profile.noData
                          }}
                        </p>
                        <v-divider class="mt-2"></v-divider>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-if="showInfoEdit">
                        <v-text-field
                          v-model="info.title"
                          :label="lang.fields.title"
                          hide-details
                          outlined
                          dense
                          @keydown.enter="saveInfo(saveInfo)"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-else>
                        <p class="info-title body-2 font-weight-bold mb-0">
                          {{ lang.fields.title }}
                        </p>
                        <p class="info-text body-2 mb-0">
                          {{ currentPersonImage.title || lang.profile.noData }}
                        </p>
                        <v-divider class="mt-2"></v-divider>
                      </v-col>
                      <v-col cols="12" class="px-1" v-if="showInfoEdit">
                        <v-textarea
                          :label="lang.fields.description"
                          hide-details
                          no-resize
                          outlined
                          rows="4"
                          dense
                          @keydown.enter="saveInfo(saveInfo)"
                          v-model="info.description"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-else>
                        <p class="info-title body-2 font-weight-bold mb-0">
                          {{ lang.fields.description }}
                        </p>
                        <p class="info-text body-2 mb-0">
                          {{
                            currentPersonImage.description ||
                            lang.profile.noData
                          }}
                        </p>
                        <v-divider class="mt-2"></v-divider>
                      </v-col>
                      <v-col cols="12" class="px-1" v-if="showInfoEdit">
                        <div class="input-group">
                          <label>{{ lang.fields.date }}</label>
                          <v-dialog
                            ref="dialogImage"
                            v-model="modalImage"
                            :return-value.sync="info.memoryDate"
                            persistent
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="info.memoryDate"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                hide-details
                                outlined
                                v-bind="attrs"
                                dense
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="info.memoryDate" scrollable>
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="modalImage = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.dialogImage.save(info.memoryDate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </div>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-else>
                        <p class="info-title body-2 font-weight-bold mb-0">
                          {{ lang.fields.date }}
                        </p>
                        <p class="info-text body-2 mb-0">
                          <v-icon class="caption mr-1">mdi-calendar</v-icon>
                          <span v-if="currentPersonImage.memoryDate">{{
                            currentPersonImage.memoryDate | shortFullDate
                          }}</span>
                          <span v-else>{{ lang.profile.noData }}</span>
                        </p>
                        <v-divider class="mt-2"></v-divider>
                      </v-col>
                      <v-col
                        v-if="showInfoEdit"
                        cols="12"
                        class="pt-0 mt-0 px-1"
                      >
                        <v-autocomplete
                          v-model="info.friends"
                          :disabled="isUpdating"
                          :items="people"
                          chips
                          outlined
                          color="primary"
                          :label="lang.fields.targeted"
                          item-text="name"
                          item-value="name"
                          multiple
                        >
                          <template v-slot:selection="data">
                            <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              close
                              @click="data.select"
                              @click:close="remove(data.item)"
                            >
                              <v-avatar
                                width="25"
                                height="25"
                                min-height="25"
                                min-width="25"
                                color="grey"
                              >
                                <v-img
                                  v-if="data.item.avatar"
                                  :src="data.item.avatar"
                                  :alt="'Avatar ' + data.item.name"
                                  :lazy-src="
                                    require('../assets/images/lazy-loading.png')
                                  "
                                ></v-img>
                                <div v-else>
                                  {{ getFullNameInitials(data.item.name) }}
                                </div>
                              </v-avatar>
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="isTypeOf(data)">
                              <v-list-item-content>{{
                                data.item
                              }}</v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-avatar
                                width="33"
                                height="33"
                                min-height="33"
                                min-width="33"
                                color="grey"
                              >
                                <v-img
                                  v-if="data.item.avatar"
                                  :src="data.item.avatar"
                                  :alt="'Avatar ' + data.item.name"
                                  :lazy-src="
                                    require('../assets/images/lazy-loading.png')
                                  "
                                ></v-img>
                                <div v-else>
                                  {{ getFullNameInitials(data.item.name) }}
                                </div>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  data.item.name
                                }}</v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-else>
                        <p class="info-title body-2 mb-0 font-weight-bold">
                          {{ lang.fields.targeted }}
                        </p>
                        <div
                          v-if="
                            currentPersonImage.friends &&
                            currentPersonImage.friends.length
                          "
                        >
                          <v-chip
                            v-for="(el, index) in currentPersonImage.friends"
                            :key="'user' + index"
                            class="mr-1 mt-1"
                          >
                            {{ el }}
                          </v-chip>
                        </div>
                        <p v-else class="info-text body-2 mb-0">
                          {{ lang.profile.noData }}
                        </p>
                      </v-col>
                      <v-col
                        class="d-flex justify-end px-1"
                        v-if="showInfoEdit"
                      >
                        <v-btn
                          color="primary"
                          small
                          text
                          @click="closeEditInfoDialog()"
                          elevation="0"
                        >
                          {{ lang.actions.close }}
                        </v-btn>
                        <v-btn
                          small
                          class="btn-bg ml-2"
                          elevation="0"
                          @click="saveInfoDialog('image')"
                        >
                          {{ lang.actions.save }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </div>
              <v-icon
                v-if="showLikes"
                :class="{
                  'red--text': entityLiked(currentPersonImage.likes),
                  'white--text': !entityLiked(currentPersonImage.likes),
                }"
                @click="
                  manageLike(
                    2,
                    currentPersonImage.likes,
                    currentPersonImage.id,
                    'image'
                  )
                "
                class="mr-1 cursor-pointer display-1"
                >mdi-heart</v-icon
              >
              <span
                v-if="showLikes"
                class="text-underline cursor-pointer subtitle-1 mt-n2 text-shadow"
                @click="viewLikes(currentPersonImage.likes)"
                >{{ currentPersonImage.likes.length | shortCount }}</span
              >
              <v-icon
                v-if="showBookmarks"
                @click="manageBookmark(currentPersonImage, 'Image')"
                :class="{
                  'orange--text': currentPersonImage.bookmarkedByLoggedInUser,
                  'white--text': !currentPersonImage.bookmarkedByLoggedInUser,
                }"
                class="mr-1 cursor-pointer display-1 mt-1"
                >mdi-bookmark</v-icon
              >
              <v-icon
                class="mr-1 cursor-pointer display-1 mt-1 white--text"
                @click="shareContent(imageShowIndex, 'image')"
                >mdi-share</v-icon
              >
              <v-icon
                @click="
                  openDialogReportImageModal(personData.images[imageShowIndex])
                "
                v-if="currentUser.id != personData.userId"
                class="mr-1 cursor-pointer display-1 mt-1 white--text"
                >mdi-flag</v-icon
              >
              <v-icon
                v-if="showImageAndVideoComments"
                class="mr-1 cursor-pointer title-2 mt-3 white--text show-mobile"
                @click="showComments('images')"
                >mdi-comment-multiple</v-icon
              >
            </div>
            <v-icon
              @click="leftImage()"
              class="back-image"
              v-if="imageShowIndex != 0"
              >mdi-chevron-left</v-icon
            >
            <v-icon
              v-if="
                personData.images &&
                imageShowIndex != personData.images.length - 1
              "
              @click="rightImage()"
              class="next-image"
              >mdi-chevron-right</v-icon
            >
            <div>
              <img
                v-if="currentPersonImage && currentPersonImage.imageUrl"
                :src="currentPersonImage.imageUrl"
                alt="Person Image"
                :lazy-src="require('../assets/images/lazy-loading.png')"
              />
            </div>
          </v-col>
          <v-col
            class="col-12 comment-container"
            :class="{
              show: showComment,
              'col-md-3': showImageAndVideoComments,
            }"
            v-if="
              (imageShowIndex != null || imageShowIndex == 0) &&
              !threadList &&
              showImageAndVideoComments
            "
          >
            <div class="px-2 pt-6 comments">
              <div class="comment-x show-mobile">
                <v-icon @click="showComments('images')">mdi-close</v-icon>
              </div>
              <div
                v-if="
                  currentPersonImage &&
                  currentPersonImage.comments &&
                  currentPersonImage.comments.length
                "
              >
                <div
                  class="d-flex mb-3 comment-item"
                  v-for="(comment, index) in currentPersonImage.comments"
                  :key="index"
                >
                  <v-list-item-avatar
                    width="33"
                    height="33"
                    min-height="33"
                    min-width="33"
                    color="grey"
                    class="py-0 my-0 mr-2 ml-1"
                  >
                    <v-img
                      v-if="comment.userImageUrl"
                      :src="comment.userImageUrl"
                      :alt="comment.fullName"
                      :lazy-src="require('../assets/images/lazy-loading.png')"
                    ></v-img>
                    <div v-else>
                      {{ getFullNameInitials(comment.fullName) }}
                    </div>
                  </v-list-item-avatar>
                  <div style="width: 100%">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <p
                          class="font-weight-bold mt-0 mb-0 d-flex justify-space-between"
                        >
                          <span>{{ comment.fullName }}</span>
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="mt-n1 mb-2 caption-1 cursor-pointer"
                          >
                            {{ comment.createdAt | getFormattedDate }}
                          </span>
                        </p>
                      </template>
                      <span>{{ getDate(comment.createdAt) }}</span>
                    </v-tooltip>
                    <p
                      class="mb-1"
                      :id="'ddd' + index"
                      :class="{ 'green--text': editCommentId == comment.id }"
                    >
                      {{ comment.text }}
                      <v-icon
                        v-if="comment.userId == currentUser.id"
                        :class="{ 'green--text': editCommentId == comment.id }"
                        class="cursor-pointer subtitle-1 mx-2"
                        @click="editComment(comment)"
                        >mdi-pencil</v-icon
                      >
                      <v-icon
                        v-if="comment.userId == currentUser.id"
                        @click="
                          deleteCommentDialog(comment, 'comment', 'image')
                        "
                        class="subtitle-1 cursor-pointer"
                        >mdi-trash-can-outline</v-icon
                      >
                      <v-icon
                        v-if="comment.userId != currentUser.id"
                        class="cursor-pointer subtitle-1 mx-2"
                        @click="openDialogReportCommentModal(comment)"
                        >mdi-flag</v-icon
                      >
                    </p>
                    <div class="d-flex justify-space-between mb-1">
                      <span class="caption"
                        ><v-icon
                          v-if="showLikes"
                          class="cursor-pointer"
                          :class="{
                            'red--text': entityLiked(comment.likes),
                            'gray--text': !entityLiked(comment.likes),
                          }"
                          @click="
                            manageLike(
                              3,
                              comment.likes,
                              comment.id,
                              'imageComment'
                            )
                          "
                          >mdi-heart</v-icon
                        >
                        <span
                          v-if="showLikes"
                          class="ml-2"
                          :class="{
                            'text-underline cursor-pointer':
                              comment.likes.length,
                          }"
                          @click="viewLikes(comment.likes)"
                          >{{ comment.likes.length | shortCount }}</span
                        ></span
                      >
                      <span
                        class="caption cursor-pointer font-weight-bold grey--text text-underline"
                        @click="seeThreadsOverlay(comment)"
                        >{{ comment.thread.length | shortCount }}
                        {{ lang.profile.threadsExtra }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="pl-4">
                <h3>
                  <v-icon class="mr-2"
                    >mdi-comment-text-multiple-outline</v-icon
                  >
                  {{ lang.profile.noComments }}
                </h3>
              </div>
            </div>
            <!-- <div class="comments" v-else>
                <v-skeleton-loader
                  type="article, article, article, article"
                ></v-skeleton-loader>
              </div> -->
            <div class="my-comment input-group pl-2 pr-0 d-flex">
              <textarea
                :placeholder="lang.fields.leaveAComment"
                rows="4"
                @keydown.enter="leaveCommentOnImage()"
                v-model="imageComment"
              ></textarea>
              <div
                class="d-flex flex-column justify-space-between align-center"
                style="height: 115px"
              >
                <v-list-item-avatar
                  width="30"
                  height="30"
                  min-height="30"
                  min-width="30"
                  color="grey"
                  class="py-0 my-0 mr-1 ml-3"
                >
                  <v-img
                    v-if="currentUser.profileImageUrl"
                    :src="currentUser.profileImageUrl"
                    :alt="currentUser.name + ' ' + currentUser.lastName"
                    :lazy-src="require('../assets/images/lazy-loading.png')"
                  ></v-img>
                  <div v-else>
                    {{
                      getUserInitials(currentUser.name, currentUser.lastName)
                    }}
                  </div>
                </v-list-item-avatar>
                <v-icon
                  v-if="editCommentId"
                  class="ml-3 mr-1 cursor-pointer red--text"
                  @click="closeEditComment()"
                  >mdi-close</v-icon
                >
                <v-icon
                  class="ml-3 mr-1 cursor-pointer"
                  @click="leaveCommentOnImage()"
                  >mdi-send</v-icon
                >
              </div>
            </div>
            <!-- <div class="my-comment" v-else>
                <v-skeleton-loader type="article"></v-skeleton-loader>
              </div> -->
          </v-col>
          <v-col
            class="col-12 comment-container"
            :class="{
              show: showComment,
              'col-md-3': showImageAndVideoComments,
            }"
            v-else-if="showImageAndVideoComments"
          >
            <div class="px-2 pt-4 comments" v-if="threadList">
              <div class="d-flex justify-space-between align-start">
                <p class="subtitle-2 font-weight-bold">
                  {{ lang.profile.threads }}
                </p>
                <v-icon @click="closeThreadOverlay()">mdi-close</v-icon>
              </div>
              <div class="d-flex justify-space-between align-start">
                <div class="d-flex main-comment">
                  <v-list-item-avatar
                    width="33"
                    height="33"
                    min-height="33"
                    min-width="33"
                    color="grey"
                    class="py-0 my-0 mr-2 ml-1"
                  >
                    <v-img
                      v-if="threadList.userImageUrl"
                      :src="threadList.userImageUrl"
                      :alt="threadList.fullName"
                      :lazy-src="require('../assets/images/lazy-loading.png')"
                    ></v-img>
                    <div v-else>
                      {{ getFullNameInitials(threadList.fullName) }}
                    </div>
                  </v-list-item-avatar>
                  <div style="width: 100%">
                    <p
                      class="font-weight-bold mt-0 mb-0 d-flex justify-space-between"
                    >
                      <span>{{ threadList.fullName }}</span>
                    </p>
                    <p class="mb-2">
                      {{ threadList.text }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  threadList && threadList.thread && threadList.thread.length
                "
              >
                <div
                  class="d-flex ml-2 mr-1 mb-4 comment-item"
                  v-for="(comment, index) in threadList.thread"
                  :key="index + 'thread'"
                >
                  <v-list-item-avatar
                    width="33"
                    height="33"
                    min-height="33"
                    min-width="33"
                    color="grey"
                    class="py-0 my-0 mr-2 ml-1"
                  >
                    <v-img
                      v-if="comment.userImageUrl"
                      :src="comment.userImageUrl"
                      :alt="comment.fullName"
                      :lazy-src="require('../assets/images/lazy-loading.png')"
                    ></v-img>
                    <div v-else>
                      {{ getFullNameInitials(comment.fullName) }}
                    </div>
                  </v-list-item-avatar>
                  <div style="width: 100%">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <p
                          class="font-weight-bold mt-0 mb-0 d-flex justify-space-between"
                        >
                          <span>{{ comment.fullName }}</span>
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="mt-n1 mb-2 caption-1 cursor-pointer"
                          >
                            {{ comment.createdAt | getFormattedDate }}
                          </span>
                        </p>
                      </template>
                      <span>{{ getDate(comment.createdAt) }}</span>
                    </v-tooltip>
                    <p
                      class="mb-2"
                      :id="'ddd' + index"
                      :class="{ 'green--text': editCommentId == comment.id }"
                    >
                      {{ comment.text }}
                      <v-icon
                        v-if="comment.userId == currentUser.id"
                        :class="{ 'green--text': editCommentId == comment.id }"
                        class="cursor-pointer subtitle-1 mx-2"
                        @click="editComment(comment)"
                        >mdi-pencil</v-icon
                      >
                      <v-icon
                        v-if="comment.userId == currentUser.id"
                        @click="deleteCommentDialog(comment, 'thread', 'image')"
                        class="subtitle-1 cursor-pointer"
                        >mdi-trash-can-outline</v-icon
                      >
                      <v-icon
                        v-if="comment.userId != currentUser.id"
                        class="cursor-pointer subtitle-1 mx-2"
                        @click="openDialogReportCommentThreadModal(comment)"
                        >mdi-flag</v-icon
                      >
                    </p>
                    <div class="d-flex justify-space-between mb-1">
                      <span class="caption"
                        ><v-icon
                          v-if="showLikes"
                          class="cursor-pointer"
                          :class="{
                            'red--text': entityLiked(comment.likes),
                            'gray--text': !entityLiked(comment.likes),
                          }"
                          @click="
                            manageLike(
                              3,
                              comment.likes,
                              comment.id,
                              'imageCommentThread',
                              comment
                            )
                          "
                          >mdi-heart</v-icon
                        >
                        <span
                          v-if="showLikes"
                          class="ml-2"
                          :class="{
                            'text-underline cursor-pointer':
                              comment.likes.length,
                          }"
                          @click="viewLikes(comment.likes)"
                          >{{ comment.likes.length | shortCount }}</span
                        ></span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="pl-4">
                <h4>
                  <v-icon class="mr-2"
                    >mdi-comment-text-multiple-outline</v-icon
                  >
                  {{ lang.profile.noThreads }}
                </h4>
              </div>
            </div>
            <!-- <div class="comments" v-else>
                <v-skeleton-loader
                  type="article, article, article, article"
                ></v-skeleton-loader>
              </div> -->
            <div class="my-comment input-group pl-2 pr-0 d-flex">
              <textarea
                :placeholder="lang.fields.leaveAThread"
                rows="4"
                @keydown.enter="leaveCommentThreadOnImage()"
                v-model="imageCommentThread"
              ></textarea>
              <div
                class="d-flex flex-column justify-space-between align-center"
                style="height: 115px"
              >
                <v-list-item-avatar
                  width="30"
                  height="30"
                  min-height="30"
                  min-width="30"
                  color="grey"
                  class="py-0 my-0 mr-1 ml-3"
                >
                  <v-img
                    v-if="currentUser.profileImageUrl"
                    :src="currentUser.profileImageUrl"
                    :alt="currentUser.name + ' ' + currentUser.lastName"
                    :lazy-src="require('../assets/images/lazy-loading.png')"
                  ></v-img>
                  <div v-else>
                    {{
                      getUserInitials(currentUser.name, currentUser.lastName)
                    }}
                  </div>
                </v-list-item-avatar>
                <v-icon
                  v-if="editCommentId"
                  class="ml-3 mr-1 cursor-pointer red--text"
                  @click="closeEditComment()"
                  >mdi-close</v-icon
                >
                <v-icon
                  class="ml-3 mr-1 cursor-pointer"
                  @click="leaveCommentThreadOnImage()"
                  >mdi-send</v-icon
                >
              </div>
            </div>
            <!-- <div class="my-comment" v-else>
                <v-skeleton-loader type="article"></v-skeleton-loader>
              </div> -->
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogVideo"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-row class="no-gutters mx-0 my-0 mt-0" v-if="currentPersonVideo">
          <v-col
            class="col-12 image-container"
            :class="{ 'col-md-9': showImageAndVideoComments }"
          >
            <v-icon @click="closeVideoDialog()" class="close-dialog"
              >mdi-close</v-icon
            >
            <div
              class="action-dialog d-flex flex-column align-center"
              v-if="
                personData &&
                personData.videos &&
                personData.videos[videoShowIndex]
              "
            >
              <div class="show-info-relative">
                <v-icon
                  v-if="showImageAndVideoInfo"
                  @click="showInfoContainer(currentPersonVideo, 'Video')"
                  class="mr-1 cursor-pointer display-1 mb-1 white--text"
                  >mdi-information-outline</v-icon
                >
                <div class="show-info-container" v-if="showInfo">
                  <v-card class="px-4 no-shadow">
                    <v-row class="mt-0" v-if="currentPersonVideo">
                      <v-icon
                        v-if="
                          !showInfoEdit && personData.userId == currentUser.id
                        "
                        @click="editInfo(currentPersonVideo, 'video')"
                        class="edit-dialog-info"
                        small
                        style="width: 20px; height: 20px"
                        >mdi-pencil</v-icon
                      >
                      <v-icon
                        small
                        style="width: 20px; height: 20px"
                        @click="closeInfoDialog()"
                        class="close-dialog-info"
                        >mdi-close</v-icon
                      >
                      <v-col cols="12" class="mt-10 px-1" v-if="showInfoEdit">
                        <v-text-field
                          v-model="info.location"
                          :label="lang.fields.location"
                          hide-details
                          outlined
                          dense
                          @keydown.enter="saveInfo(saveInfo)"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="mt-10 px-1" v-else>
                        <p class="info-title body-2 font-weight-bold mb-0">
                          {{ lang.fields.location }}
                        </p>
                        <p class="info-text body-2 mb-0">
                          <v-icon class="caption">mdi-google-maps</v-icon>
                          {{
                            currentPersonVideo.location || lang.profile.noData
                          }}
                        </p>
                        <v-divider class="mt-2"></v-divider>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-if="showInfoEdit">
                        <v-text-field
                          v-model="info.title"
                          :label="lang.fields.title"
                          hide-details
                          outlined
                          dense
                          @keydown.enter="saveInfo(saveInfo)"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-else>
                        <p class="info-title body-2 font-weight-bold mb-0">
                          {{ lang.fields.title }}
                        </p>
                        <p class="info-text body-2 mb-0">
                          {{ currentPersonVideo.title || lang.profile.noData }}
                        </p>
                        <v-divider class="mt-2"></v-divider>
                      </v-col>
                      <v-col cols="12" class="px-1" v-if="showInfoEdit">
                        <v-textarea
                          :label="lang.fields.description"
                          hide-details
                          no-resize
                          outlined
                          rows="4"
                          dense
                          @keydown.enter="saveInfo(saveInfo)"
                          v-model="info.description"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-else>
                        <p class="info-title body-2 font-weight-bold mb-0">
                          {{ lang.fields.description }}
                        </p>
                        <p class="info-text body-2 mb-0">
                          {{
                            currentPersonVideo.description ||
                            lang.profile.noData
                          }}
                        </p>
                        <v-divider class="mt-2"></v-divider>
                      </v-col>
                      <v-col cols="12" v-if="showInfoEdit">
                        <div class="input-group">
                          <label>{{ lang.fields.date }}</label>
                          <v-dialog
                            ref="dialogVideo"
                            v-model="modalVideo"
                            :return-value.sync="info.memoryDate"
                            persistent
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="info.memoryDate"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                hide-details
                                outlined
                                v-bind="attrs"
                                dense
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="info.memoryDate" scrollable>
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="modalVideo = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.dialogVideo.save(info.memoryDate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </div>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-else>
                        <p class="info-title body-2 font-weight-bold mb-0">
                          {{ lang.fields.date }}
                        </p>
                        <p class="info-text body-2 mb-0">
                          <v-icon class="caption">mdi-calendar</v-icon>
                          <span v-if="currentPersonVideo.memoryDate">{{
                            currentPersonVideo.memoryDate | shortFullDate
                          }}</span>
                          <span v-else>{{ lang.profile.noData }}</span>
                        </p>
                        <v-divider class="mt-2"></v-divider>
                      </v-col>
                      <v-col
                        v-if="showInfoEdit"
                        cols="12"
                        class="pt-0 mt-0 px-1"
                      >
                        <v-autocomplete
                          v-model="info.friends"
                          :disabled="isUpdating"
                          :items="people"
                          chips
                          outlined
                          color="primary"
                          :label="lang.fields.targeted"
                          item-text="name"
                          item-value="name"
                          multiple
                        >
                          <template v-slot:selection="data">
                            <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              close
                              @click="data.select"
                              @click:close="remove(data.item)"
                            >
                              <v-avatar
                                width="25"
                                height="25"
                                min-height="25"
                                min-width="25"
                                color="grey"
                              >
                                <v-img
                                  v-if="data.item.avatar"
                                  :src="data.item.avatar"
                                  :alt="'Avatar ' + data.item.name"
                                  :lazy-src="
                                    require('../assets/images/lazy-loading.png')
                                  "
                                ></v-img>
                                <div v-else>
                                  {{ getFullNameInitials(data.item.name) }}
                                </div>
                              </v-avatar>
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="isTypeOf(data)">
                              <v-list-item-content>{{
                                data.item
                              }}</v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-avatar
                                width="33"
                                height="33"
                                min-height="33"
                                min-width="33"
                                color="grey"
                              >
                                <v-img
                                  v-if="data.item.avatar"
                                  :src="data.item.avatar"
                                  :alt="'Avatar ' + data.item.name"
                                  :lazy-src="
                                    require('../assets/images/lazy-loading.png')
                                  "
                                ></v-img>
                                <div v-else>
                                  {{ getFullNameInitials(data.item.name) }}
                                </div>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  data.item.name
                                }}</v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" class="pt-0 px-1" v-else>
                        <p class="info-title body-2 mb-0 font-weight-bold">
                          {{ lang.fields.targeted }}
                        </p>
                        <div
                          v-if="
                            currentPersonVideo.friends &&
                            currentPersonVideo.friends.length
                          "
                        >
                          <v-chip
                            v-for="(el, index) in currentPersonVideo.friends"
                            :key="'user' + index"
                            class="mr-1 mt-1"
                          >
                            {{ el }}
                          </v-chip>
                        </div>
                        <p v-else class="info-text body-2 mb-0">
                          {{ lang.profile.noData }}
                        </p>
                      </v-col>
                      <v-col
                        class="d-flex justify-end px-1"
                        v-if="showInfoEdit"
                      >
                        <v-btn
                          color="primary"
                          small
                          text
                          @click="closeEditInfoDialog()"
                          elevation="0"
                        >
                          {{ lang.actions.close }}
                        </v-btn>
                        <v-btn
                          small
                          class="btn-bg ml-2"
                          elevation="0"
                          @click="saveInfoDialog('video')"
                        >
                          {{ lang.actions.save }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </div>
              <v-icon
                v-if="showLikes"
                :class="{
                  'red--text': entityLiked(currentPersonVideo.likes),
                  'white--text': !entityLiked(currentPersonVideo.likes),
                }"
                @click="
                  manageLike(
                    1,
                    currentPersonVideo.likes,
                    currentPersonVideo.id,
                    'video'
                  )
                "
                class="mr-1 cursor-pointer display-1"
                >mdi-heart</v-icon
              >
              <span
                v-if="showLikes"
                class="text-underline cursor-pointer subtitle-1 mt-n2 text-shadow"
                @click="viewLikes(currentPersonVideo.likes)"
                >{{ currentPersonVideo.likes.length | shortCount }}</span
              >
              <v-icon
                v-if="showBookmarks"
                @click="manageBookmark(currentPersonVideo, 'Video')"
                :class="{
                  'orange--text': currentPersonVideo.bookmarkedByLoggedInUser,
                  'white--text': !currentPersonVideo.bookmarkedByLoggedInUser,
                }"
                class="mr-1 cursor-pointer display-1 mt-1"
                >mdi-bookmark</v-icon
              >
              <v-icon
                class="mr-1 cursor-pointer display-1 mt-1 white--text"
                @click="shareContent(videoShowIndex, 'video')"
                >mdi-share</v-icon
              >
              <v-icon
                @click="
                  openDialogReportVideoModal(personData.videos[videoShowIndex])
                "
                v-if="currentUser.id != personData.userId"
                class="mr-1 cursor-pointer display-1 mt-1 white--text"
                >mdi-flag</v-icon
              >
              <v-icon
                v-if="showImageAndVideoComments"
                class="mr-1 cursor-pointer display-1 mt-3 white--text show-mobile"
                @click="showComments('videos')"
                >mdi-comment-multiple</v-icon
              >
            </div>
            <v-icon
              @click="leftVideo()"
              class="back-image"
              v-if="videoShowIndex != 0"
              >mdi-chevron-left</v-icon
            >
            <v-icon
              v-if="
                personData.videos &&
                videoShowIndex != personData.videos.length - 1
              "
              @click="rightVideo()"
              class="next-image"
              >mdi-chevron-right</v-icon
            >
            <div class="d-flex justify-center">
              <video
                controls
                style="width: 100%"
                v-if="currentPersonVideoUrl"
                :key="currentPersonVideoUrl"
                controlsList="nodownload"
              >
                <source :src="currentPersonVideoUrl" type="video/mp4" />
                <source :src="currentPersonVideoUrl" type="video/webm" />
                <source :src="currentPersonVideoUrl" type="video/ogg" />
                <source :src="currentPersonVideoUrl" type="video/quicktime" />
                <source :src="currentPersonVideoUrl" type="video/x-msvideo" />
                <source :src="currentPersonVideoUrl" type="video/x-matroska" />
                Your browser does not support the video tag.
              </video>
            </div>
          </v-col>
          <v-col
            class="col-12 comment-container"
            :class="{
              show: showComment,
              'col-md-3': showImageAndVideoComments,
            }"
            v-if="
              (videoShowIndex != null || videoShowIndex == 0) &&
              !threadList &&
              showImageAndVideoComments
            "
          >
            <div class="px-2 pt-6 comments">
              <div class="comment-x show-mobile">
                <v-icon @click="showComments('images')">mdi-close</v-icon>
              </div>
              <div
                v-if="
                  currentPersonVideo &&
                  currentPersonVideo.comments &&
                  currentPersonVideo.comments.length
                "
              >
                <div
                  class="d-flex mb-4 comment-item"
                  v-for="(comment, index) in currentPersonVideo.comments"
                  :key="index"
                >
                  <v-list-item-avatar
                    width="33"
                    height="33"
                    min-height="33"
                    min-width="33"
                    color="grey"
                    class="py-0 my-0 mr-2 ml-1"
                  >
                    <v-img
                      v-if="comment.userImageUrl"
                      :src="comment.userImageUrl"
                      :alt="comment.fullName"
                      :lazy-src="require('../assets/images/lazy-loading.png')"
                    ></v-img>
                    <div v-else>
                      {{ getFullNameInitials(comment.fullName) }}
                    </div>
                  </v-list-item-avatar>
                  <div style="width: 100%">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <p
                          class="font-weight-bold mt-0 mb-0 d-flex justify-space-between"
                        >
                          <span>{{ comment.fullName }}</span>
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="mt-n1 mb-2 caption-1 cursor-pointer"
                          >
                            {{ comment.createdAt | getFormattedDate }}
                          </span>
                        </p>
                      </template>
                      <span>{{ getDate(comment.createdAt) }}</span>
                    </v-tooltip>
                    <p
                      class="mb-0"
                      :id="'ddd' + index"
                      :class="{ 'green--text': editCommentId == comment.id }"
                    >
                      {{ comment.text }}
                      <v-icon
                        v-if="comment.userId == currentUser.id"
                        :class="{ 'green--text': editCommentId == comment.id }"
                        class="cursor-pointer subtitle-1 mx-2"
                        @click="editComment(comment)"
                        >mdi-pencil</v-icon
                      >
                      <v-icon
                        v-if="comment.userId == currentUser.id"
                        @click="
                          deleteCommentDialog(comment, 'comment', 'video')
                        "
                        class="subtitle-1 cursor-pointer"
                        >mdi-trash-can-outline</v-icon
                      >
                      <v-icon
                        v-if="comment.userId != currentUser.id"
                        class="cursor-pointer subtitle-1 mx-2"
                        @click="openDialogReportCommentModal(comment)"
                        >mdi-flag</v-icon
                      >
                    </p>
                    <div class="d-flex justify-space-between mb-1">
                      <span class="caption"
                        ><v-icon
                          v-if="showLikes"
                          class="cursor-pointer"
                          :class="{
                            'red--text': entityLiked(comment.likes),
                            'gray--text': !entityLiked(comment.likes),
                          }"
                          @click="
                            manageLike(
                              3,
                              comment.likes,
                              comment.id,
                              'videoComment'
                            )
                          "
                          >mdi-heart</v-icon
                        >
                        <span
                          v-if="showLikes"
                          class="ml-2"
                          :class="{
                            'text-underline cursor-pointer':
                              comment.likes.length,
                          }"
                          @click="viewLikes(comment.likes)"
                          >{{ comment.likes.length | shortCount }}</span
                        >
                      </span>
                      <span
                        class="caption cursor-pointer font-weight-bold grey--text text-underline"
                        @click="seeThreadsOverlay(comment)"
                        >{{ comment.thread.length | shortCount }}
                        {{ lang.profile.threadsExtra }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="pl-4">
                <h4>
                  <v-icon class="mr-2"
                    >mdi-comment-text-multiple-outline</v-icon
                  >
                  {{ lang.profile.noComments }}
                </h4>
              </div>
            </div>
            <!-- <div class="comments" v-else>
                <v-skeleton-loader
                  type="article, article, article, article"
                ></v-skeleton-loader>
              </div> -->
            <div class="my-comment input-group pl-2 pr-0 d-flex">
              <textarea
                :placeholder="lang.fields.leaveAComment"
                rows="4"
                @keydown.enter="leaveCommentOnVideo()"
                v-model="videoComment"
              ></textarea>
              <div
                class="d-flex flex-column justify-space-between align-center"
                style="height: 115px"
              >
                <v-list-item-avatar
                  width="30"
                  height="30"
                  min-height="30"
                  min-width="30"
                  color="grey"
                  class="py-0 my-0 mr-1 ml-3"
                >
                  <v-img
                    v-if="currentUser.profileImageUrl"
                    :src="currentUser.profileImageUrl"
                    :alt="currentUser.name + ' ' + currentUser.lastName"
                    :lazy-src="require('../assets/images/lazy-loading.png')"
                  ></v-img>
                  <div v-else>
                    {{
                      getUserInitials(currentUser.name, currentUser.lastName)
                    }}
                  </div>
                </v-list-item-avatar>
                <v-icon
                  v-if="editCommentId"
                  class="ml-3 mr-1 cursor-pointer red--text"
                  @click="closeEditComment()"
                  >mdi-close</v-icon
                >
                <v-icon
                  class="ml-3 mr-1 cursor-pointer"
                  @click="leaveCommentOnVideo()"
                  >mdi-send</v-icon
                >
              </div>
            </div>
            <!-- <div class="my-comment" v-else>
                <v-skeleton-loader type="article"></v-skeleton-loader>
              </div> -->
          </v-col>
          <v-col
            class="col-12 comment-container"
            :class="{
              show: showComment,
              'col-md-3': showImageAndVideoComments,
            }"
            v-else-if="showImageAndVideoComments"
          >
            <div class="px-2 pt-4 comments" v-if="threadList">
              <div class="d-flex justify-space-between align-start">
                <p class="subtitle-2 font-weight-bold">
                  {{ lang.profile.threads }}
                </p>
                <v-icon @click="closeThreadOverlay()">mdi-close</v-icon>
              </div>
              <div class="d-flex justify-space-between align-start">
                <div class="d-flex main-comment">
                  <v-list-item-avatar
                    width="33"
                    height="33"
                    min-height="33"
                    min-width="33"
                    color="grey"
                    class="py-0 my-0 mr-2 ml-1"
                  >
                    <v-img
                      v-if="threadList.userImageUrl"
                      :src="threadList.userImageUrl"
                      :alt="threadList.fullName"
                      :lazy-src="require('../assets/images/lazy-loading.png')"
                    ></v-img>
                    <div v-else>
                      {{ getFullNameInitials(threadList.fullName) }}
                    </div>
                  </v-list-item-avatar>
                  <div style="width: 100%">
                    <p
                      class="font-weight-bold mt-0 mb-0 d-flex justify-space-between"
                    >
                      <span>{{ threadList.fullName }}</span>
                    </p>
                    <p class="mb-2">
                      {{ threadList.text }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  threadList && threadList.thread && threadList.thread.length
                "
              >
                <div
                  class="d-flex ml-2 mr-1 mb-4 comment-item"
                  v-for="(comment, index) in threadList.thread"
                  :key="index + 'thread'"
                >
                  <v-list-item-avatar
                    width="33"
                    height="33"
                    min-height="33"
                    min-width="33"
                    color="grey"
                    class="py-0 my-0 mr-2 ml-1"
                  >
                    <v-img
                      v-if="comment.userImageUrl"
                      :src="comment.userImageUrl"
                      :alt="comment.fullName"
                      :lazy-src="require('../assets/images/lazy-loading.png')"
                    ></v-img>
                    <div v-else>
                      {{ getFullNameInitials(comment.fullName) }}
                    </div>
                  </v-list-item-avatar>
                  <div style="width: 100%">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <p
                          class="font-weight-bold mt-0 mb-0 d-flex justify-space-between"
                        >
                          <span>{{ comment.fullName }}</span>
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="mt-n1 mb-2 caption-1 cursor-pointer"
                          >
                            {{ comment.createdAt | getFormattedDate }}
                          </span>
                        </p>
                      </template>
                      <span>{{ getDate(comment.createdAt) }}</span>
                    </v-tooltip>
                    <p
                      class="mb-2"
                      :id="'ddd' + index"
                      :class="{ 'green--text': editCommentId == comment.id }"
                    >
                      {{ comment.text }}
                      <v-icon
                        v-if="comment.userId == currentUser.id"
                        :class="{ 'green--text': editCommentId == comment.id }"
                        class="cursor-pointer subtitle-1 mx-2"
                        @click="editComment(comment)"
                        >mdi-pencil</v-icon
                      >
                      <v-icon
                        v-if="comment.userId == currentUser.id"
                        @click="deleteCommentDialog(comment, 'thread', 'video')"
                        class="subtitle-1 cursor-pointer"
                        >mdi-trash-can-outline</v-icon
                      >
                      <v-icon
                        v-if="comment.userId != currentUser.id"
                        class="cursor-pointer subtitle-1 mx-2"
                        @click="openDialogReportCommentThreadModal(comment)"
                        >mdi-flag</v-icon
                      >
                    </p>
                    <div class="d-flex justify-space-between mb-1">
                      <span class="caption"
                        ><v-icon
                          v-if="showLikes"
                          class="cursor-pointer"
                          :class="{
                            'red--text': entityLiked(comment.likes),
                            'gray--text': !entityLiked(comment.likes),
                          }"
                          @click="
                            manageLike(
                              3,
                              comment.likes,
                              comment.id,
                              'videoCommentThread',
                              comment
                            )
                          "
                          >mdi-heart</v-icon
                        >
                        <span
                          v-if="showLikes"
                          class="ml-2"
                          :class="{
                            'text-underline cursor-pointer':
                              comment.likes.length,
                          }"
                          @click="viewLikes(comment.likes)"
                          >{{ comment.likes.length | shortCount }}</span
                        ></span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="pl-4">
                <h4>
                  <v-icon class="mr-2"
                    >mdi-comment-text-multiple-outline</v-icon
                  >
                  {{ lang.profile.noThreads }}
                </h4>
              </div>
            </div>
            <!-- <div class="comments" v-else>
                <v-skeleton-loader
                  type="article, article, article, article"
                ></v-skeleton-loader>
              </div> -->
            <div class="my-comment input-group pl-2 pr-0 d-flex">
              <textarea
                :placeholder="lang.fields.leaveAThread"
                rows="4"
                @keydown.enter="leaveCommentThreadOnVideo()"
                v-model="videoCommentThread"
              ></textarea>
              <div
                class="d-flex flex-column justify-space-between align-center"
                style="height: 115px"
              >
                <v-list-item-avatar
                  width="30"
                  height="30"
                  min-height="30"
                  min-width="30"
                  color="grey"
                  class="py-0 my-0 mr-1 ml-3"
                >
                  <v-img
                    v-if="currentUser.profileImageUrl"
                    :src="currentUser.profileImageUrl"
                    :alt="currentUser.name + ' ' + currentUser.lastName"
                    :lazy-src="require('../assets/images/lazy-loading.png')"
                  ></v-img>
                  <div v-else>
                    {{
                      getUserInitials(currentUser.name, currentUser.lastName)
                    }}
                  </div>
                </v-list-item-avatar>
                <v-icon
                  v-if="editCommentId"
                  class="ml-3 mr-1 cursor-pointer red--text"
                  @click="closeEditComment()"
                  >mdi-close</v-icon
                >
                <v-icon
                  class="ml-3 mr-1 cursor-pointer"
                  @click="leaveCommentThreadOnVideo()"
                  >mdi-send</v-icon
                >
              </div>
            </div>
            <!-- <div class="my-comment" v-else>
                <v-skeleton-loader type="article"></v-skeleton-loader>
              </div> -->
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="lastGreetingModel"
      class="rounded-xl"
      persistent
      max-width="600px"
    >
      <v-card
        style="
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
          border-radius: 12px;
        "
      >
        <v-card-title class="px-3">
          <span class="gc-text-h6"
            >{{ lang.profile.w2 }} {{ personMetrics.deceasedFullName }}
          </span>
        </v-card-title>
        <v-card-text class="pb-0 mb-0 px-3">
          <v-form ref="dialogLastGreetingForm">
            <div class="input-group mb-4">
              <label>{{ lang.fields.note }} *</label>
              <textarea
                v-model="lastGreetingNote"
                @keydown.enter="addLastGreeting()"
                rows="8"
              ></textarea>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            small
            text
            @click="lastGreetingModel = false"
            elevation="0"
          >
            {{ lang.actions.close }}
          </v-btn>
          <v-btn small class="btn-bg" elevation="0" @click="addLastGreeting()">
            {{ currentGreeting ? lang.actions.edit : lang.actions.add }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div>
      <v-row>
        <v-col class="col-12 col-md-4 col-lg-3 column-center pt-0-mobile">
          <v-card
            v-if="Object.keys(personMetrics).length === 0"
            style="
              width: 100%;
              box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
              border-radius: 12px;
            "
            elevation="0"
          >
            <v-skeleton-loader
              type="image, list-item-three-line, list-item-two-line, list-item-two-line, list-item-two-line"
            ></v-skeleton-loader>
          </v-card>
          <v-card
            elevation="0"
            style="
              width: 100%;
              box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
              border-radius: 12px;
            "
            v-else
          >
            <v-card-text class="column-center text-center">
              <v-btn
                class="edit-pen"
                text
                outlined
                v-if="personData.userId == currentUser.id && !editMode"
                icon
                color="primary"
                @click="setEditMode(true)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                class="share-social-profile"
                text
                outlined
                icon
                color="primary"
              >
                <v-icon @click="shareContent(personData, 'profile')"
                  >mdi-share</v-icon
                >
              </v-btn>
              <v-btn class="qr-code" text outlined icon color="primary">
                <v-icon @click="showQrCodePopup = true">mdi-qrcode-scan</v-icon>
              </v-btn>
              <!-- todo -->
              <!-- <v-btn v-if="currentUser.id == personData.userId" class="package-info" text outlined icon color="primary">
                <v-icon @click="pickPackage = true">mdi-package-variant</v-icon>
              </v-btn> -->
              <v-btn
                class="report-pen"
                text
                outlined
                v-if="personData.userId != currentUser.id && !editMode"
                icon
                @click="openDialogReportProfileModal()"
              >
                <v-icon>mdi-flag</v-icon>
              </v-btn>
              <div class="rel">
                <v-img
                  v-if="personMetrics.deceasedImageUrl"
                  class="user-image"
                  aspect-ratio="1"
                  style="border-radius: 50%"
                  :src="personMetrics.deceasedImageUrl"
                  :alt="personMetrics.deceasedFullName"
                  :lazy-src="require('../assets/images/lazy-loading.png')"
                ></v-img>
                <v-img
                  class="user-image"
                  aspect-ratio="1"
                  style="border-radius: 50%"
                  :alt="personMetrics.deceasedFullName"
                  :lazy-src="require('../assets/images/lazy-loading.png')"
                  v-else
                  :src="getUserProfileImage(personMetrics.gender)"
                ></v-img>
                <div
                  class="input-image-container border-primary"
                  v-if="personData.userId == currentUser.id"
                  @click="triggerFileUpload()"
                >
                  <div class="camera-container">
                    <v-icon>mdi-camera</v-icon>
                  </div>
                  <v-file-input
                    ref="fileInput"
                    style="display: none"
                    @change="onProfileImgUpload"
                    accept="image/*"
                    v-model="newProfileImage"
                    hide-input
                    show-size
                    prepend-icon="mdi-camera"
                    truncate-length="27"
                  ></v-file-input>
                </div>
              </div>
              <p
                class="headline mt-4 font-weight-bold"
                :class="{
                  'mb-2': !personMetrics.nickname,
                  'mb-0': personMetrics.nickname,
                }"
              >
                {{ `${personMetrics.deceasedFullName || ""}` }}
              </p>
              <p
                class="caption mt-0 mb-2 font-weight-bold"
                v-if="personMetrics.nickname"
              >
                {{ `${personMetrics.nickname}` }}
              </p>
              <span class="caption">{{
                getBirthToDeathDate(
                  personMetrics.dateOfBirth,
                  personMetrics.dateOfDeath
                )
              }}</span>
              <div class="profile-stats profile-stats--user">
                <div class="text-center mb-2">
                  <p class="display-1 mb-0">
                    {{
                      getPersonAge(
                        personMetrics.dateOfBirth,
                        personMetrics.dateOfDeath
                      )
                    }}
                  </p>
                  <span class="overline">{{ lang.profile.age }}</span>
                </div>
                <div class="text-center mb-2">
                  <p class="display-1 mb-0">
                    {{
                      personMetrics.numberOfPictures +
                      (showPackage ? `/${showPackage.images}` : "")
                    }}
                  </p>
                  <span class="overline">{{ lang.profile.photos }}</span>
                </div>
                <div class="text-center mb-2">
                  <p class="display-1 mb-0">
                    {{
                      personMetrics.numberOfVideos +
                      (showPackage ? `/${showPackage.videos}` : "")
                    }}
                  </p>
                  <span class="overline">{{ lang.profile.videos }}</span>
                </div>
                <div class="text-center mb-2">
                  <p class="display-1 mb-0">
                    {{
                      personMetrics.numberOfDocuments +
                      (showPackage ? `/${showPackage.documents}` : "")
                    }}
                  </p>
                  <span class="overline">{{ lang.profile.documents }}</span>
                </div>
                <div
                  class="text-center mb-2 cursor-pointer"
                  @click="showFollowers()"
                >
                  <p class="display-1 mb-0 primary--text">
                    {{ personMetrics.numberOfFollowers | shortCount }}
                  </p>
                  <span class="overline primary--text">{{
                    lang.profile.followers
                  }}</span>
                </div>
                <div class="text-center mb-2">
                  <p class="display-1 mb-0">
                    {{ personMetrics.numberOfLastGreetings | shortCount }}
                    {{
                      showPackage
                        ? `${
                            showPackage.lastGreetings == "Unlimited"
                              ? ""
                              : "/" + showPackage.lastGreetings
                          }`
                        : ""
                    }}
                  </p>
                  <span class="overline">{{ lang.profile.greetings }}</span>
                </div>
                <div class="text-center full-width">
                  <v-btn
                    v-if="personMetrics.didLoggedUserSendFollowingInvitation"
                    elevation="0"
                    small
                    class="mt-4 btn-bg mx-1"
                    :disabled="true"
                    >{{ lang.actions.requestSent }}</v-btn
                  >
                  <v-btn
                    v-else-if="
                      personMetrics.didLoggedUserReceiveFollowingInvitation
                    "
                    elevation="0"
                    color="#000!important"
                    class="mt-4 mx-1"
                    small
                    @click="seePendingRequest()"
                    text
                    >{{ lang.actions.viewRequests }}</v-btn
                  >
                  <v-btn
                    v-else-if="!personMetrics.isLoggedUserOwnerOrFollower"
                    elevation="0"
                    small
                    class="mt-4 btn-bg mx-1"
                    @click="sendRequestModal(personMetrics)"
                    >{{ lang.actions.sendRequest }}</v-btn
                  >
                  <v-btn
                    v-if="personData.userId == currentUser.id"
                    elevation="0"
                    small
                    class="mt-4 btn-bg mx-1"
                    @click="dialogInvite = true"
                    >{{ lang.actions.inviteFollowers }}</v-btn
                  >
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="col-12 col-md-8 col-lg-9">
          <v-card
            v-if="Object.keys(personData).length === 0"
            style="
              width: 100%;
              box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
              border-radius: 12px;
            "
            elevation="0"
          >
            <v-skeleton-loader
              type="article, article, article, table-heading"
            ></v-skeleton-loader>
          </v-card>
          <v-card
            elevation="0"
            style="
              box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
              border-radius: 12px;
            "
            v-else
          >
            <v-form ref="profileForm">
              <v-card-text
                class="pt-7 profile-stats"
                :class="{ 'edit-mode': editMode }"
              >
                <section class="mb-2">
                  <WeeklyTales
                    @getDeceasedStories="getDeceasedStories"
                    :weeklyTales="personStories"
                    :showAdd="currentUser.id == personData.userId"
                  />
                </section>
                <div class="full-row px-0">
                  <v-expansion-panels class="mb-6" v-model="activePanel">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        class="py-0"
                        @click="togglePanel = !togglePanel"
                      >
                        <span class="font-weight-bold subtitle-1">{{
                          lang.profile.general
                        }}</span>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row class="mt-0 pb-4">
                          <v-row class="px-2">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.personalInfo
                              }}</span>
                            </v-col>
                            <v-col
                              v-if="editMode"
                              cols="12"
                              sm="6"
                              md="3"
                              class="pt-0"
                            >
                              <div
                                class="input-group"
                                v-if="personMetrics.isHuman"
                              >
                                <label>{{ lang.fields.name }} *</label>
                                <input
                                  type="text"
                                  v-model="personData.firstName"
                                />
                              </div>
                              <div v-else class="input-group">
                                <label>{{ lang.fields.name }} *</label>
                                <input type="text" v-model="personData.name" />
                              </div>
                            </v-col>

                            <v-col
                              v-if="editMode && personMetrics.isHuman"
                              cols="12"
                              sm="6"
                              md="3"
                              class="pt-0"
                            >
                              <div class="input-group">
                                <label>{{ lang.fields.surname }} *</label>
                                <input
                                  type="text"
                                  v-model="personData.lastName"
                                />
                              </div>
                            </v-col>

                            <v-col
                              v-if="editMode"
                              cols="12"
                              sm="6"
                              md="3"
                              class="pt-0"
                            >
                              <div class="input-group">
                                <label>{{ lang.fields.nickname }}</label>
                                <input
                                  type="text"
                                  v-model="personData.nickname"
                                />
                              </div>
                            </v-col>
                            <v-col
                              v-if="personMetrics.isHuman"
                              cols="12"
                              sm="6"
                              md="3"
                              class="pt-0"
                            >
                              <div>
                                <div class="mb-2" v-if="!editMode">
                                  <p class="mb-1">
                                    <span class="overline d-block mb-n2">{{
                                      lang.fields.occupation
                                    }}</span>
                                    {{ personData.occupation || "-" }}
                                  </p>
                                </div>
                                <div v-else>
                                  <div class="input-group">
                                    <label>{{ lang.fields.occupation }}</label>
                                    <input
                                      type="text"
                                      v-model="personData.occupation"
                                    />
                                  </div>
                                </div>
                              </div>
                            </v-col>

                            <v-col
                              v-if="editMode"
                              cols="12"
                              sm="6"
                              md="3"
                              class="pt-0 custom-input"
                            >
                              <div class="input-group">
                                <label>{{
                                  lang.fields.birthDate + " *"
                                }}</label>
                                <v-dialog
                                  ref="dialogBirth"
                                  v-model="modalBirth"
                                  :return-value.sync="personData.dateOfBirth"
                                  persistent
                                  width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="personData.dateOfBirth"
                                      prepend-inner-icon="mdi-calendar"
                                      readonly
                                      hide-details
                                      outlined
                                      v-bind="attrs"
                                      dense
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="personData.dateOfBirth"
                                    scrollable
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="modalBirth = false"
                                    >
                                      Cancel
                                    </v-btn>
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="
                                        $refs.dialogBirth.save(
                                          personData.dateOfBirth
                                        )
                                      "
                                    >
                                      OK
                                    </v-btn>
                                  </v-date-picker>
                                </v-dialog>
                              </div>
                            </v-col>

                            <v-col
                              v-if="editMode"
                              cols="12"
                              sm="6"
                              md="3"
                              class="pt-0 custom-input"
                            >
                              <div class="input-group">
                                <label>{{
                                  lang.fields.deathDate + " *"
                                }}</label>
                                <v-dialog
                                  ref="dialogDeath"
                                  v-model="modalDeath"
                                  :return-value.sync="personData.dateOfDeath"
                                  persistent
                                  width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="personData.dateOfDeath"
                                      prepend-inner-icon="mdi-calendar"
                                      readonly
                                      hide-details
                                      outlined
                                      v-bind="attrs"
                                      dense
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="personData.dateOfDeath"
                                    scrollable
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="modalDeath = false"
                                    >
                                      Cancel
                                    </v-btn>
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="
                                        $refs.dialogDeath.save(
                                          personData.dateOfDeath
                                        )
                                      "
                                    >
                                      OK
                                    </v-btn>
                                  </v-date-picker>
                                </v-dialog>
                              </div>
                            </v-col>

                            <v-col
                              cols="12"
                              sm="12"
                              :md="!editMode ? 3 : 6"
                              class="pt-0"
                            >
                              <span
                                class="overline d-block mb-n2"
                                v-if="!editMode"
                                >{{ lang.fields.gender }}</span
                              >
                              <div v-if="!editMode">
                                <p class="mb-1">
                                  {{ personData.gender || "-" }}
                                </p>
                              </div>
                              <div v-else class="d-flex mt-n3">
                                <v-radio-group
                                  hide-details
                                  :rules="[rules.required]"
                                  v-model="personData.gender"
                                  row
                                  class="pt-6"
                                >
                                  <v-radio
                                    :label="lang.fields.other"
                                    value="Other"
                                    :ripple="false"
                                  ></v-radio>
                                  <v-radio
                                    :label="lang.fields.male"
                                    value="Male"
                                    :ripple="false"
                                  ></v-radio>
                                  <v-radio
                                    :label="lang.fields.female"
                                    value="Female"
                                    :ripple="false"
                                  ></v-radio>
                                </v-radio-group>
                              </div>
                            </v-col>

                            <v-col
                              v-if="!personMetrics.isHuman"
                              cols="12"
                              sm="6"
                              md="3"
                              class="pt-0"
                            >
                              <div>
                                <div v-if="!editMode">
                                  <span class="overline d-block mb-n2">{{
                                    lang.fields.chipId
                                  }}</span>
                                  <p class="mb-1">
                                    {{ personData.chipId || "-" }}
                                  </p>
                                </div>
                                <div v-else>
                                  <div class="input-group">
                                    <label>{{ lang.fields.chipId }}</label>
                                    <input
                                      type="text"
                                      v-model="personData.chipId"
                                    />
                                  </div>
                                </div>
                              </div>
                            </v-col>

                            <v-col
                              v-if="!personMetrics.isHuman"
                              cols="12"
                              sm="6"
                              md="3"
                              class="pt-0"
                            >
                              <div>
                                <div v-if="!editMode">
                                  <span class="overline d-block mb-n2">{{
                                    lang.fields.breed
                                  }}</span>
                                  <p class="mb-1">
                                    {{ personData.breed || "-" }}
                                  </p>
                                </div>
                                <div v-else>
                                  <div class="input-group">
                                    <label>{{ lang.fields.breed }}</label>
                                    <input
                                      type="text"
                                      v-model="personData.breed"
                                    />
                                  </div>
                                </div>
                              </div>
                            </v-col>

                            <v-col
                              v-if="!personMetrics.isHuman"
                              cols="12"
                              sm="6"
                              md="3"
                              class="pt-0"
                            >
                              <div>
                                <div v-if="!editMode">
                                  <span class="overline d-block mb-n2">{{
                                    lang.fields.species
                                  }}</span>
                                  <p class="mb-1">
                                    {{ personData.species || "-" }}
                                  </p>
                                </div>
                                <div v-else>
                                  <div class="input-group">
                                    <label>{{ lang.fields.species }}</label>
                                    <input
                                      type="text"
                                      v-model="personData.species"
                                    />
                                  </div>
                                </div>
                              </div>
                            </v-col>

                            <v-col
                              v-if="!personMetrics.isHuman"
                              cols="12"
                              sm="6"
                              md="3"
                              class="pt-0"
                            >
                              <div>
                                <div v-if="!editMode">
                                  <span class="overline d-block mb-n2">{{
                                    lang.fields.passport
                                  }}</span>
                                  <p class="mb-1">
                                    {{ personData.passportId || "-" }}
                                  </p>
                                </div>
                                <div v-else>
                                  <div class="input-group">
                                    <label>{{ lang.fields.passport }}</label>
                                    <input
                                      type="text"
                                      v-model="personData.passportId"
                                    />
                                  </div>
                                </div>
                              </div>
                            </v-col>

                            <v-col
                              v-if="personMetrics.isHuman"
                              cols="12"
                              sm="6"
                              md="3"
                              class="pt-0"
                            >
                              <div>
                                <div v-if="!editMode">
                                  <span class="overline d-block mb-n2">{{
                                    lang.fields.zodiacSign
                                  }}</span>
                                  <p class="mb-1">
                                    {{ personData.zodiacSign || "-" }}
                                  </p>
                                </div>
                                <div v-else>
                                  <div class="input-group">
                                    <label>{{ lang.fields.zodiacSign }}</label>
                                    <input
                                      type="text"
                                      v-model="personData.zodiacSign"
                                    />
                                  </div>
                                </div>
                              </div>
                            </v-col>

                            <v-col cols="12" sm="6" md="3" class="pt-0">
                              <div v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields.eyeColor
                                }}</span>
                                <p class="mb-1">
                                  {{ personData.eyeColor || "-" }}
                                </p>
                              </div>
                              <div v-else>
                                <div class="input-group">
                                  <label>{{ lang.fields.eyeColor }}</label>
                                  <input
                                    type="text"
                                    v-model="personData.eyeColor"
                                  />
                                </div>
                              </div>
                            </v-col>

                            <v-col cols="12" sm="6" md="3" class="pt-0">
                              <div v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields.height
                                }}</span>
                                <p class="mb-1">
                                  {{ personData.height || "-" }}
                                </p>
                              </div>
                              <div v-else>
                                <div class="input-group">
                                  <label>{{ lang.fields.height }}</label>
                                  <input
                                    type="text"
                                    v-model="personData.height"
                                  />
                                </div>
                              </div>
                            </v-col>

                            <v-col cols="12" sm="6" md="3" class="pt-0">
                              <div v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields.weight
                                }}</span>
                                <p class="mb-1">
                                  {{ personData.weight || "-" }}
                                </p>
                              </div>
                              <div v-else>
                                <div class="input-group">
                                  <label>{{ lang.fields.weight }}</label>
                                  <input
                                    type="text"
                                    v-model="personData.weight"
                                  />
                                </div>
                              </div>
                            </v-col>

                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.fields.location
                              }}</span>
                            </v-col>

                            <v-col cols="12" sm="6" md="3" class="pt-0">
                              <div v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields.country
                                }}</span>
                                <p class="mb-1">
                                  {{ personData.country || "-" }}
                                </p>
                              </div>
                              <div v-else class="custom-input">
                                <div class="input-group">
                                  <label>{{ lang.fields.country }}</label>
                                  <v-autocomplete
                                    :items="countriesDropdown"
                                    prepend-inner-icon="mdi-earth"
                                    outlined
                                    dense
                                    hide-details
                                    v-model="personData.country"
                                  ></v-autocomplete>
                                </div>
                              </div>
                            </v-col>

                            <v-col cols="12" sm="6" md="3" class="pt-0">
                              <div v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields.city
                                }}</span>
                                <p class="mb-1">
                                  {{ personData.city || "-" }}
                                </p>
                              </div>
                              <div v-else>
                                <div class="input-group">
                                  <label>{{ lang.fields.city }}</label>
                                  <input
                                    type="text"
                                    v-model="personData.city"
                                  />
                                </div>
                              </div>
                            </v-col>

                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.graveInfo
                              }}</span>
                            </v-col>

                            <v-col
                              class="col-12 pt-0"
                              v-if="
                                !editMode &&
                                personData.graveLocationLat &&
                                personData.graveLocationLng
                              "
                            >
                              <div
                                id="map"
                                style="height: 300px; margin-top: 16px"
                              ></div>
                            </v-col>
                            <v-col class="col-12" v-if="editMode">
                              <v-switch
                                hide-details
                                inset
                                class="ml-1 mr-3"
                                :ripple="false"
                                v-model="useCurrentLocation"
                                :label="lang.fields.useCurrentLocation"
                              ></v-switch>
                            </v-col>
                            <v-col class="col-12 col-md-6 pt-0" v-if="editMode">
                              <div class="input-group">
                                <label>{{ lang.fields.latitude }}</label>
                                <input
                                  type="text"
                                  v-model="personData.graveLocationLat"
                                />
                              </div>
                            </v-col>
                            <v-col class="col-12 col-md-6 pt-0" v-if="editMode">
                              <div class="input-group">
                                <label>{{ lang.fields.longitude }}</label>
                                <input
                                  type="text"
                                  v-model="personData.graveLocationLng"
                                />
                              </div>
                            </v-col>

                            <v-col cols="12" md="6" class="pt-0">
                              <div v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields.graveCountry
                                }}</span>
                                <p class="mb-1">
                                  {{ personData.graveLocationCountry || "-" }}
                                </p>
                              </div>
                              <div v-else>
                                <div class="input-group">
                                  <label>{{ lang.fields.graveCountry }}</label>
                                  <input
                                    type="text"
                                    v-model="personData.graveLocationCountry"
                                  />
                                </div>
                              </div>
                            </v-col>

                            <v-col cols="12" md="6" class="pt-0">
                              <div v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields.graveCity
                                }}</span>
                                <p class="mb-1">
                                  {{ personData.graveLocationCity || "-" }}
                                </p>
                              </div>
                              <div v-else>
                                <div class="input-group">
                                  <label>{{ lang.fields.graveCity }}</label>
                                  <input
                                    type="text"
                                    v-model="personData.graveLocationCity"
                                  />
                                </div>
                              </div>
                            </v-col>

                            <v-col cols="12" class="pt-0">
                              <div v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields.graveDescription
                                }}</span>
                                <p class="mb-1">
                                  {{
                                    personData.graveLocationDescription || "-"
                                  }}
                                </p>
                              </div>
                              <div v-else>
                                <div class="input-group">
                                  <label>{{
                                    lang.fields.graveDescription
                                  }}</label>
                                  <textarea
                                    v-model="
                                      personData.graveLocationDescription
                                    "
                                    rows="4"
                                  ></textarea>
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
                <div class="full-row px-0">
                  <v-expansion-panels
                    class="mb-4"
                    v-model="activePanelFavorites"
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-header class="py-0">
                        <span class="font-weight-bold subtitle-1">{{
                          lang.profile.favorites
                        }}</span>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row class="mt-0 pb-4" v-if="personMetrics.isHuman">
                          <v-row class="px-2">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.food
                              }}</span>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              :class="{ 'pb-0': !editMode }"
                              v-for="favorite in foodArray"
                              :key="favorite.type"
                            >
                              <div class="text-left mb-0" v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields[favorite.type]
                                }}</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <p v-bind="attrs" v-on="on" class="mb-0">
                                      {{ favorite.value || "-" }}
                                    </p>
                                  </template>
                                  <span>{{ favorite.value || "-" }}</span>
                                </v-tooltip>
                              </div>
                              <div v-else>
                                <div class="input-group">
                                  <label>{{
                                    lang.fields[favorite.type]
                                  }}</label>
                                  <input type="text" v-model="favorite.value" />
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="px-2 pb-4 pt-5">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.drinks
                              }}</span>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              :class="{ 'pb-0': !editMode }"
                              v-for="favorite in drinkArray"
                              :key="favorite.type"
                            >
                              <div class="text-left mb-0" v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields[favorite.type]
                                }}</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <p v-bind="attrs" v-on="on" class="mb-0">
                                      {{ favorite.value || "-" }}
                                    </p>
                                  </template>
                                  <span>{{ favorite.value || "-" }}</span>
                                </v-tooltip>
                              </div>
                              <div v-else>
                                <div class="input-group">
                                  <label>{{
                                    lang.fields[favorite.type]
                                  }}</label>
                                  <input type="text" v-model="favorite.value" />
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="px-2 pb-4 pt-5">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.movies
                              }}</span>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              :class="{ 'pb-0': !editMode }"
                              v-for="favorite in movieArray"
                              :key="favorite.type"
                            >
                              <div class="text-left mb-0" v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields[favorite.type]
                                }}</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <p v-bind="attrs" v-on="on" class="mb-0">
                                      {{ favorite.value || "-" }}
                                    </p>
                                  </template>
                                  <span>{{ favorite.value || "-" }}</span>
                                </v-tooltip>
                              </div>
                              <div v-else>
                                <div class="input-group">
                                  <label>{{
                                    lang.fields[favorite.type]
                                  }}</label>
                                  <input type="text" v-model="favorite.value" />
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="px-2 pb-4 pt-5">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.musics
                              }}</span>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              :class="{ 'pb-0': !editMode }"
                              v-for="favorite in musicArray"
                              :key="favorite.type"
                            >
                              <div class="text-left mb-0" v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields[favorite.type]
                                }}</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <p v-bind="attrs" v-on="on" class="mb-0">
                                      {{ favorite.value || "-" }}
                                    </p>
                                  </template>
                                  <span>{{ favorite.value || "-" }}</span>
                                </v-tooltip>
                              </div>
                              <div v-else>
                                <div class="input-group">
                                  <label>{{
                                    lang.fields[favorite.type]
                                  }}</label>
                                  <input type="text" v-model="favorite.value" />
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="px-2 pb-4 pt-5" style="width: 100%">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.books
                              }}</span>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              :class="{ 'pb-0': !editMode }"
                              v-for="favorite in booksArray"
                              :key="favorite.type"
                            >
                              <div class="text-left mb-0" v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields[favorite.type]
                                }}</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <p v-bind="attrs" v-on="on" class="mb-0">
                                      {{ favorite.value || "-" }}
                                    </p>
                                  </template>
                                  <span>{{ favorite.value || "-" }}</span>
                                </v-tooltip>
                              </div>
                              <div v-else>
                                <div class="input-group">
                                  <label>{{
                                    lang.fields[favorite.type]
                                  }}</label>
                                  <input type="text" v-model="favorite.value" />
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="px-2 pb-4 pt-5" style="width: 100%">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.sports
                              }}</span>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              :class="{ 'pb-0': !editMode }"
                              v-for="favorite in sportArray"
                              :key="favorite.type"
                            >
                              <div class="text-left mb-0" v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields[favorite.type]
                                }}</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <p v-bind="attrs" v-on="on" class="mb-0">
                                      {{ favorite.value || "-" }}
                                    </p>
                                  </template>
                                  <span>{{ favorite.value || "-" }}</span>
                                </v-tooltip>
                              </div>
                              <div v-else>
                                <div class="input-group">
                                  <label>{{
                                    lang.fields[favorite.type]
                                  }}</label>
                                  <input type="text" v-model="favorite.value" />
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="px-2 pb-4 pt-5">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.lifestyle
                              }}</span>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              :class="{ 'pb-0': !editMode }"
                              v-for="favorite in lifestyleArray"
                              :key="favorite.type"
                            >
                              <div class="text-left mb-0" v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields[favorite.type]
                                }}</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <p v-bind="attrs" v-on="on" class="mb-0">
                                      {{ favorite.value || "-" }}
                                    </p>
                                  </template>
                                  <span>{{ favorite.value || "-" }}</span>
                                </v-tooltip>
                              </div>
                              <div v-else>
                                <div class="input-group">
                                  <label>{{
                                    lang.fields[favorite.type]
                                  }}</label>
                                  <input type="text" v-model="favorite.value" />
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="px-2 pb-4 pt-5">
                            <v-col cols="12">
                              <span class="title primary--text">{{
                                lang.addMemories.travel
                              }}</span>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              :class="{ 'pb-0': !editMode }"
                              v-for="favorite in travelArray"
                              :key="favorite.type"
                            >
                              <div class="text-left mb-0" v-if="!editMode">
                                <span class="overline d-block mb-n2">{{
                                  lang.fields[favorite.type]
                                }}</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <p v-bind="attrs" v-on="on" class="mb-0">
                                      {{ favorite.value || "-" }}
                                    </p>
                                  </template>
                                  <span>{{ favorite.value || "-" }}</span>
                                </v-tooltip>
                              </div>
                              <div v-else>
                                <div class="input-group">
                                  <label>{{
                                    lang.fields[favorite.type]
                                  }}</label>
                                  <input type="text" v-model="favorite.value" />
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-row>
                        <v-row v-else class="mt-0 pb-4">
                          <v-col
                            cols="12"
                            sm="6"
                            md="3"
                            :class="{ 'pb-0': !editMode }"
                            v-for="favorite in petArray"
                            :key="favorite.type"
                          >
                            <div class="text-left mb-0" v-if="!editMode">
                              <span class="overline d-block mb-n2">{{
                                lang.fields[favorite.type]
                              }}</span>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <p v-bind="attrs" v-on="on" class="mb-0">
                                    {{ favorite.value || "-" }}
                                  </p>
                                </template>
                                <span>{{ favorite.value || "-" }}</span>
                              </v-tooltip>
                            </div>
                            <div v-else>
                              <div class="input-group">
                                <label>{{ lang.fields[favorite.type] }}</label>
                                <input type="text" v-model="favorite.value" />
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
                <div class="d-flex justify-end action-form" v-if="editMode">
                  <v-btn
                    class="primary--text"
                    text
                    @click="cancelEditMode()"
                    small
                    elevation="0"
                    >{{ lang.actions.cancel }}</v-btn
                  >
                  <v-btn
                    class="ml-2 btn-bg"
                    @click="updateProfile()"
                    small
                    elevation="0"
                    >{{ lang.actions.save }}</v-btn
                  >
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-12">
          <v-tabs
            v-model="tabSelected"
            right
            style="
              box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
              border-top-left-radius: 12px;
              border-top-right-radius: 12px;
            "
          >
            <v-tab>
              <v-icon class="mr-2">mdi-human-greeting</v-icon>
              <span class="hide-on-mobile">{{
                lang.profile.lastGreetings
              }}</span></v-tab
            >
            <v-tab
              ><v-icon class="mr-2">mdi-timeline-text</v-icon
              ><span class="hide-on-mobile">{{
                lang.profile.biography
              }}</span></v-tab
            >
            <v-tab
              ><v-icon class="mr-2">mdi-image</v-icon
              ><span class="hide-on-mobile">{{
                lang.profile.photos
              }}</span></v-tab
            >
            <v-tab
              ><v-icon class="mr-2">mdi-video</v-icon
              ><span class="hide-on-mobile">{{
                lang.profile.videos
              }}</span></v-tab
            >
            <v-tab
              ><v-icon class="mr-2">mdi-file-document</v-icon
              ><span class="hide-on-mobile">{{
                lang.profile.documents
              }}</span></v-tab
            >
            <v-tab>
              <v-icon class="mr-2">mdi-puzzle</v-icon>
              <span class="hide-on-mobile">{{
                lang.profile.missingPuzzle
              }}</span
              ><span class="suggestions-count" v-if="suggestions.length">{{
                suggestions.length
              }}</span></v-tab
            >
          </v-tabs>
          <v-skeleton-loader
            v-if="Object.keys(personData).length === 0"
            type="list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line"
          ></v-skeleton-loader>
          <v-tabs-items
            v-else
            v-model="tabSelected"
            style="
              box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
              border-bottom-left-radius: 12px;
              border-bottom-right-radius: 12px;
            "
            class="pt-8"
          >
            <v-tab-item>
              <div class="d-flex justify-end px-4">
                <!-- {{ currentPackage }} // todo remove -->
                <v-btn
                  class="btn-bg mb-4"
                  elevation="0"
                  small
                  v-if="showAddGreetingBtn"
                  @click="addLastGreetingModal()"
                  ><v-icon left>mdi-plus</v-icon
                  >{{ lang.actions.addGreeting }}</v-btn
                >
              </div>
              <div v-if="lastGreetingsLoading">
                <v-skeleton-loader
                  type="list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line"
                ></v-skeleton-loader>
              </div>
              <div v-else-if="lastGreetings.length">
                <LastGreeting
                  :currentUser="currentUser"
                  :personData="personData"
                  @deleteLastGreetingModal="deleteLastGreetingModal"
                  @openDialogReportModal="openDialogLastGreetingReportModal"
                  @editLastGreetingModal="addLastGreetingModal"
                  v-for="(lastGreeting, index) in lastGreetings"
                  :key="index"
                  :lastGreeting="lastGreeting"
                />
              </div>
              <NoResult
                v-else
                class="mt-0"
                :show="true"
                :title="lang.response.w1"
              ></NoResult>
            </v-tab-item>
            <v-tab-item>
              <Biography
                v-if="!loadingBiographies"
                :currentUser="currentUser"
                :personData="personData"
                :biographies="biographies"
                @editTimeline="editTimeline"
                @addTimeline="addTimeline"
                @deleteTimeline="deleteTimeline"
                :showAddBioBtn="showAddBioBtn"
                :showMediaBio="showMediaBio"
              ></Biography>
              <v-skeleton-loader
                v-else
                type="list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line"
              ></v-skeleton-loader>
            </v-tab-item>
            <v-tab-item>
              <div v-if="!orderImages">
                <div class="px-4 d-flex justify-end">
                  <v-btn
                    class="btn-bg mb-4 mr-2"
                    elevation="0"
                    small
                    v-if="
                      personData.userId == currentUser.id &&
                      personData.images.length &&
                      personData.images.length > 1
                    "
                    @click="startImageOrder()"
                  >
                    <v-icon> mdi-sort-ascending </v-icon>
                  </v-btn>
                  <v-btn
                    v-if="
                      personData.userId == currentUser.id && showAddImageBtn
                    "
                    class="btn-bg mb-4 mr-2"
                    elevation="0"
                    small
                    @click="triggerImageUpload()"
                  >
                    <v-icon left> mdi-upload-multiple-outline </v-icon>
                    {{ lang.actions.addImages }}
                  </v-btn>
                  <v-file-input
                    ref="imageUpload"
                    v-if="personData.userId == currentUser.id"
                    show-size
                    accept="image/*"
                    multiple
                    style="display: none"
                    dense
                    :messages="notValidImagesMessages"
                    truncate-length="12"
                    v-model="newImages"
                    color="red"
                    @change="onImageFileSelected"
                    prepend-icon=""
                    prepend-inner-icon="mdi-image"
                    filled
                    solo
                    :label="lang.actions.addImage"
                  ></v-file-input>
                </div>
                <Photos
                  @emitDeleteImage="deleteImage"
                  @emitImageShow="emitImageShow"
                  :images="personImages.items"
                  :personData="personData"
                  :currentUser="currentUser"
                ></Photos>
                <v-pagination
                  v-if="personImages.items && personImages.items.length"
                  class="mt-4"
                  v-model="imagePageIndex"
                  :length="imageCount"
                  :total-visible="6"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @input="getPersonImages()"
                ></v-pagination>
              </div>
              <div class="" v-else>
                <div class="px-4 d-flex justify-end">
                  <v-btn
                    class="btn-bg mb-4"
                    elevation="0"
                    small
                    @click="saveOrderImages"
                  >
                    <v-icon left>mdi-check</v-icon>
                    {{ lang.actions.save }}
                  </v-btn>
                  <v-btn
                    class="btn-bg mb-4 ml-2"
                    elevation="0"
                    small
                    @click="cancelOrderImages"
                  >
                    <v-icon left>mdi-close</v-icon>
                    {{ lang.actions.cancel }}
                  </v-btn>
                </div>
                <OrderItems
                  :items="imagesOrder"
                  @reorder="handleReorderImage"
                />
              </div>
            </v-tab-item>
            <v-tab-item>
              <div v-if="!orderVideos">
                <div class="px-4 d-flex justify-end">
                  <v-btn
                    class="btn-bg mb-4 mr-2"
                    elevation="0"
                    small
                    v-if="
                      personData.userId == currentUser.id &&
                      personData.videos.length &&
                      personData.videos.length > 1
                    "
                    @click="startVideoOrder()"
                  >
                    <v-icon> mdi-sort-ascending </v-icon>
                  </v-btn>
                  <v-btn
                    v-if="
                      personData.userId == currentUser.id && showAddVideoBtn
                    "
                    class="btn-bg mb-4 mr-2"
                    elevation="0"
                    small
                    @click="triggerVideoUpload()"
                  >
                    <v-icon left> mdi-upload-multiple-outline </v-icon>
                    {{ lang.actions.addVideo }}
                  </v-btn>
                  <v-file-input
                    ref="videoUpload"
                    v-if="personData.userId == currentUser.id"
                    show-size
                    accept="video/mp4, video/webm, video/ogg, video/quicktime, video/x-msvideo, video/x-matroska"
                    style="display: none"
                    dense
                    :messages="notValidVideoMessages"
                    truncate-length="12"
                    v-model="newVideos"
                    color="red"
                    @change="onVideoFileSelected"
                    prepend-icon=""
                    prepend-inner-icon="mdi-video"
                    filled
                    solo
                    :label="lang.actions.addVideo"
                  ></v-file-input>
                </div>
                <Videos
                  @emitDeleteVideo="deleteVideo"
                  @emitVideoShow="emitVideoShow"
                  :videos="personVideos.items"
                  :personData="personData"
                  :currentUser="currentUser"
                ></Videos>
              </div>
              <div class="" v-else>
                <div class="px-4 d-flex justify-end">
                  <v-btn
                    class="btn-bg mb-4"
                    elevation="0"
                    small
                    @click="saveOrderVideos"
                  >
                    <v-icon left>mdi-check</v-icon>
                    {{ lang.actions.save }}
                  </v-btn>
                  <v-btn
                    class="btn-bg mb-4 ml-2"
                    elevation="0"
                    small
                    @click="cancelOrderVideos"
                  >
                    <v-icon left>mdi-close</v-icon>
                    {{ lang.actions.cancel }}
                  </v-btn>
                </div>
                <OrderItems
                  :items="videosOrder"
                  @reorder="handleReorderVideo"
                />
              </div>
            </v-tab-item>
            <v-tab-item>
              <div v-if="!orderDocuments">
                <div class="px-4 d-flex justify-end">
                  <v-btn
                    class="btn-bg mb-4 mr-2"
                    elevation="0"
                    small
                    v-if="
                      personData.userId == currentUser.id &&
                      personData.documents.length &&
                      personData.documents.length > 1
                    "
                    @click="startDocumentOrder()"
                  >
                    <v-icon> mdi-sort-ascending </v-icon>
                  </v-btn>
                  <v-btn
                    v-if="
                      personData.userId == currentUser.id && showAddDocumentBtn
                    "
                    class="btn-bg mb-4 mr-2"
                    elevation="0"
                    small
                    @click="triggerDocumentUpload()"
                  >
                    <v-icon left> mdi-upload-multiple-outline </v-icon>
                    {{ lang.actions.addDocuments }}
                  </v-btn>
                  <v-file-input
                    ref="documentUpload"
                    v-if="personData.userId == currentUser.id"
                    show-size
                    accept=".pdf, .doc, .docx, .xls, .xlsx, .txt"
                    multiple
                    style="display: none"
                    dense
                    truncate-length="12"
                    v-model="newDocuments"
                    color="red"
                    @change="onDocumentFileSelected"
                    prepend-icon=""
                    prepend-inner-icon="mdi-file-document"
                    filled
                    solo
                    :label="lang.actions.addDocuments"
                  ></v-file-input>
                </div>
                <Documents
                  @delete-person-document="deletePersonDocument"
                  v-if="
                    personDocuments &&
                    personDocuments.items &&
                    personDocuments.items.length
                  "
                  :documents="personDocuments.items"
                  :personData="personData"
                  :currentUser="currentUser"
                ></Documents>
                <NoResult
                  v-else
                  class="mt-0"
                  :show="true"
                  :title="lang.profile.noData"
                ></NoResult>

                <v-pagination
                  v-if="
                    personDocuments.items &&
                    personDocuments.items &&
                    personDocuments.items.length
                  "
                  class="mt-10"
                  v-model="documentPageIndex"
                  :length="documentsCount"
                  :total-visible="6"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @input="getPersonImages()"
                ></v-pagination>
              </div>
              <div class="" v-else>
                <div class="px-4 d-flex justify-end">
                  <v-btn
                    class="btn-bg mb-4"
                    elevation="0"
                    small
                    @click="saveOrderDocuments"
                  >
                    <v-icon left>mdi-check</v-icon>
                    {{ lang.actions.save }}
                  </v-btn>
                  <v-btn
                    class="btn-bg mb-4 ml-2"
                    elevation="0"
                    small
                    @click="cancelOrderDocuments"
                  >
                    <v-icon left>mdi-close</v-icon>
                    {{ lang.actions.cancel }}
                  </v-btn>
                </div>
                <OrderItems
                  :items="documentsOrder"
                  @reorder="handleReorderDocument"
                />
              </div>
            </v-tab-item>
            <v-tab-item>
              <div v-if="currentUser.id !== personData.userId">
                <v-row class="mx-4 pb-0">
                  <v-col class="col-12 pb-0">
                    <v-alert
                      class="py-2"
                      border="left"
                      colored-border
                      color="border-primary"
                      elevation="2"
                    >
                      <p class="caption mb-0">
                        {{ lang.profile.suggestions.suggestNewPhotos }}
                      </p>
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row class="mx-4 mt-0 mb-4">
                  <v-col class="col-12">
                    <div class="upload-files-container">
                      <VueUploadComponent
                        ref="upload"
                        v-model="files"
                        :accept="'image/*'"
                        :custom-action="customAction"
                        :multiple="true"
                        :drop="true"
                      >
                        <v-icon class="display-1 mb-2">mdi-upload</v-icon>
                        <h3>{{ lang.general.dragDropImages }}</h3>
                        <h3 class="my-4">{{ lang.login.or }}</h3>
                        <v-btn class="btn-bg" elevation="0">{{
                          lang.actions.addImages
                        }}</v-btn>
                      </VueUploadComponent>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div v-else>
                <v-row class="mx-0 pb-0">
                  <v-col
                    class="col-12 pb-0"
                    v-if="
                      showSuggestPhoto &&
                      personData.userId == currentUser.id &&
                      suggestions.length
                    "
                  >
                    <v-alert
                      class="py-2"
                      border="left"
                      colored-border
                      color="border-primary"
                      elevation="2"
                    >
                      <p class="caption mb-0">
                        {{ lang.profile.suggestions.newPhotoSuggestion }}
                      </p>
                    </v-alert>
                  </v-col>
                  <v-col class="col-12 pb-0" v-if="showSuggestPhoto">
                    <v-row
                      v-if="selectedSuggestion && selectedSuggestion.length"
                    >
                      <v-col class="col-12 d-flex align-center px-0-mobile">
                        <v-icon class="go-back" @click="closeSuggestedItems()"
                          >mdi-arrow-left</v-icon
                        >
                        <v-checkbox
                          @click="toggleAll()"
                          v-model="selectAllSuggestedImages"
                          class="mx-2 mt-0 pt-0"
                          label="Select all"
                          hide-details
                          :ripple="false"
                          dense
                        ></v-checkbox>
                        <v-spacer></v-spacer>
                        <v-btn
                          class="btn-bg mr-2"
                          small
                          elevation="0"
                          :disabled="!pickedImages.length"
                          @click="openConfirmSuggestedDialog('accept')"
                        >
                          {{ lang.actions.accept }}
                        </v-btn>
                        <v-btn
                          class="red--text"
                          text
                          small
                          outlined
                          elevation="0"
                          :disabled="!pickedImages.length"
                          @click="openConfirmSuggestedDialog('delete')"
                        >
                          {{ lang.actions.delete }}
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row
                      class="px-0 no-padding-mobile"
                      v-if="!selectedSuggestion && suggestions.length"
                    >
                      <v-col
                        class="col-12 col-md-4 pb-0"
                        v-for="suggestion in suggestions"
                        :key="suggestion.id"
                      >
                        <div
                          class="suggested-container"
                          @click="getSuggestedImageByUser(suggestion)"
                        >
                          <div class="mx-auto">
                            <v-avatar
                              width="40"
                              height="40"
                              min-height="40"
                              min-width="40"
                              color="grey"
                            >
                              <v-img
                                v-if="suggestion.profileImageUrl"
                                :src="suggestion.profileImageUrl"
                                :alt="suggestion.fullName"
                                :lazy-src="
                                  require('../assets/images/lazy-loading.png')
                                "
                              ></v-img>
                              <div v-else>
                                {{ getFullNameInitials(suggestion.fullName) }}
                              </div>
                            </v-avatar>
                          </div>
                          <div class="suggested-content">
                            <p class="subtitle-2 font-weight-bold">
                              {{ suggestion.fullName }}
                            </p>
                            <p class="caption grey--text">
                              {{ suggestion.createdAt | getFormattedDate }}
                            </p>
                          </div>
                          <div>
                            <h3
                              class="display-1 font-weight-bold primary--text mb-n2"
                            >
                              {{ suggestion.totalSuggestion }}
                            </h3>
                            <p class="subtitle-2 grey--text">images</p>
                          </div>
                          <div>
                            <v-icon>mdi-arrow-right</v-icon>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <NoResult
                      v-else-if="!suggestions.length"
                      class="mt-0"
                      :show="true"
                      :title="lang.profile.suggestions.noSuggestions"
                    ></NoResult>
                    <v-row class="px-0" v-else-if="selectedSuggestion">
                      <v-col
                        style="position: relative"
                        class="pr-0 pb-0"
                        cols="6"
                        sm="3"
                        md="2"
                        lg="2"
                        v-for="image in selectedSuggestion"
                        :key="image.suggestionId"
                      >
                        <span
                          class="click-to-select"
                          @click="toggleImageSelect(image.suggestionId)"
                          v-if="!pickedImages.includes(image.suggestionId)"
                          >Click to select</span
                        >
                        <v-icon
                          class="image-checked"
                          v-if="pickedImages.includes(image.suggestionId)"
                          @click="toggleImageSelect(image.suggestionId)"
                          >mdi-check</v-icon
                        >
                        <v-img
                          :src="image.url"
                          :alt="image.id"
                          :lazy-src="
                            require('../assets/images/lazy-loading.png')
                          "
                          aspect-ratio="1"
                          @click="toggleImageSelect(image.suggestionId)"
                          style="cursor: pointer"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="col-12 pb-0" v-else>
                    <v-alert
                      elevation="1"
                      class="py-2"
                      border="left"
                      colored-border
                      color="border-primary"
                      >{{
                        personData.userId == currentUser.id
                          ? lang.profile.suggestions.notAvailableOwner
                          : lang.profile.suggestions.notAvailable
                      }}</v-alert
                    >
                  </v-col>
                </v-row>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
  
  <script>
import OrderDigitalGifts from "@/components/OrderDigitalGifts.vue";
import DeleteProfileDialog from "@/components/ProfileDialogs/DeleteProfileDialog.vue";
import PickPackage from "@/components/ProfileDialogs/PickPackage.vue";
import DeleteItemModal from "@/components/ProfileDialogs/DeleteItemModal.vue";
import SuggestedImagesConfirmDialogModal from "@/components/ProfileDialogs/SuggestedImagesConfirmDialogModal.vue";
import ShowShareSocialActionsPopup from "@/components/ProfileDialogs/ShowShareSocialActionsPopup.vue";
import LikesDialog from "@/components/ProfileDialogs/LikesDialog.vue";
import FollowersDialog from "@/components/ProfileDialogs/FollowersDialog.vue";
import ShowQrCodeDialog from "@/components/ProfileDialogs/ShowQrCodeDialog.vue";
import DeleteCommentDialog from "@/components/ProfileDialogs/DeleteCommentDialog.vue";
import FollowDialog from "@/components/ProfileDialogs/FollowDialog.vue";
import DeleteLastGreetingsDialog from "@/components/ProfileDialogs/DeleteLastGreetingsDialog.vue";
import ReportGreetingDialog from "@/components/ProfileDialogs/ReportGreetingDialog.vue";
import ReportProfileDialog from "@/components/ProfileDialogs/ReportProfileDialog.vue";
import ReportImageDialog from "@/components/ProfileDialogs/ReportImageDialog.vue";
import ReportVideoDialog from "@/components/ProfileDialogs/ReportVideoDialog.vue";
import ReportCommentDialog from "@/components/ProfileDialogs/ReportCommentDialog.vue";
import ReportCommentThreadDialog from "@/components/ProfileDialogs/ReportCommentThreadDialog.vue";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { mapGetters } from "vuex";
import Biography from "@/components/ProfileTabs/Biography.vue";
import Photos from "@/components/ProfileTabs/Photos.vue";
import Documents from "@/components/ProfileTabs/Documents.vue";
import Videos from "@/components/ProfileTabs/Videos.vue";
import LastGreeting from "@/components/ProfileTabs/LastGreeting.vue";
import NoResult from "../components/noResult";
import helpers from "../plugins/helpers.js";
import moment from "moment";
import WeeklyTales from "../components/WeeklyTales.vue";
import Compressor from "compressorjs";
import VueUploadComponent from "vue-upload-component/src/FileUpload.vue";
import packagesList from "../script/packages.js";
import OrderItems from "@/components/OrderItems.vue";

delete L.Icon.Default.prototype._getIconUrl; // Reset default icon

L.Icon.Default.mergeOptions({
  iconRetinaUrl: "/img/mapIcons/marker-icon-2x.png",
  iconUrl: "/img/mapIcons/marker-icon.png",
  shadowUrl: "/img/mapIcons/marker-shadow.png",
});

export default {
  name: "Profile",
  data() {
    return {
      dialogShowOrderDigitalGifts: false, // todo open this dialog when user clicks on the button
      showDeleteProfileDialog: false,
      pickPackage: false,
      modalImage: false,
      modalVideo: false,
      modalBirth: false,
      modalDeath: false,
      useCurrentLocation: false,
      togglePanel: false,
      map: null,
      marker: null, // current marker
      orderImages: false,
      orderVideos: false,
      orderDocuments: false,
      activePanel: null,
      activePanelFavorites: null,
      showComment: false,
      deleteDialogId: null,
      deleteDialog: false,
      deleteDialogType: null,
      suggestedActionType: "",
      suggestedImagesConfirmDialog: false,
      selectAllSuggestedImages: false,
      pickedImages: [],
      videoPageIndex: 1,
      videoPageSize: 18,
      imagePageSize: 18,
      imagePageIndex: 1,
      documentPageIndex: 1,
      documentPageSize: 18,
      files: [],
      dialogFollow: false,
      description: "",
      showInfoEdit: false,
      isUpdating: false,
      info: {
        imageId: "",
        location: "",
        title: "",
        description: "",
        memoryDate: null,
        friends: [],
      },
      showInfo: false,
      showQrCodePopup: false,
      shareableLink: "",
      shareableDescription: "",
      shareableQuote: "",
      showShareSocialActionsPopup: false,
      networks: [
        {
          network: "viber",
          name: "Viber",
          icon: "mdi-viber",
          color: "#59267c",
        },
        {
          network: "email",
          name: "Email",
          icon: "mdi-email-outline",
          color: "#333333",
        },
        {
          network: "reddit",
          name: "Reddit",
          icon: "mdi-reddit",
          color: "#ff4500",
        },
        {
          network: "facebook",
          name: "Facebook",
          icon: "mdi-facebook",
          color: "#1877f2",
        },
        {
          network: "linkedin",
          name: "LinkedIn",
          icon: "mdi-linkedin",
          color: "#007bb5",
        },
        {
          network: "messenger",
          name: "Messenger",
          icon: "mdi-facebook-messenger",
          color: "#0084ff",
        },
        {
          network: "pinterest",
          name: "Pinterest",
          icon: "mdi-pinterest",
          color: "#bd081c",
        },
        {
          network: "skype",
          name: "Skype",
          icon: "mdi-skype-business",
          color: "#00aff0",
        },
        {
          network: "telegram",
          name: "Telegram",
          icon: "mdi-telegram",
          color: "#0088cc",
        },
        {
          network: "twitter",
          name: "Twitter",
          icon: "mdi-twitter",
          color: "#1da1f2",
        },
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: "mdi-whatsapp",
          color: "#25d366",
        },
      ],
      blob: "",
      newProfileImage: null,
      newImages: null,
      newVideos: null,
      newDocuments: null,
      reportReason: "",
      reportOther: "",
      threadList: null,
      notValidImagesMessages: [],
      notValidVideoMessages: [],
      imageComment: "",
      imageCommentThread: "",
      videoCommentThread: "",
      videoComment: "",
      imageShowIndex: null,
      videoShowIndex: null,
      dialog: false,
      dialogVideo: false,
      dialogFollowers: false,
      tabSelected: 0,
      dialogInvite: false,
      inviteEmails: [],
      inviteEmail: "",
      inviteDescription: "",
      editMode: false,
      personDataClone: {},
      dateOfBirthMenu: false,
      lastGreetingNote: "",
      lastGreetingModel: false,
      openDeleteGreetingModel: false,
      openReportGreetingModel: false,
      openReportProfileModel: false,
      openReportImageModel: false,
      openReportVideoModel: false,
      openReportCommentModel: false,
      openReportCommentThreadModel: false,
      currentGreeting: null,
      currentImage: null,
      currentVideo: null,
      currentComment: null,
      currentVideoThread: null,
      editCommentId: null,
      commentForDelete: null,
      openDeleteCommentModel: false,
    };
  },
  components: {
    OrderDigitalGifts,
    DeleteProfileDialog,
    PickPackage,
    ShowShareSocialActionsPopup,
    DeleteItemModal,
    SuggestedImagesConfirmDialogModal,
    LikesDialog,
    FollowersDialog,
    ShowQrCodeDialog,
    DeleteCommentDialog,
    FollowDialog,
    DeleteLastGreetingsDialog,
    ReportGreetingDialog,
    ReportProfileDialog,
    ReportImageDialog,
    ReportVideoDialog,
    ReportCommentDialog,
    ReportCommentThreadDialog,
    VueUploadComponent,
    WeeklyTales,
    Biography,
    Photos,
    Documents,
    Videos,
    LastGreeting,
    NoResult,
    OrderItems,
  },
  computed: {
    ...mapGetters(["rules", "lazyLoadingUrl"]),
    ...mapGetters("person", ["personData", "followerList", "personMetrics"]),
    ...mapGetters("images", [
      "currentPersonImage",
      "personImages",
      "imagesOrder",
    ]),
    ...mapGetters("videos", [
      "currentPersonVideo",
      "personVideos",
      "videosOrder",
    ]),
    ...mapGetters("documents", ["personDocuments", "documentsOrder"]),
    ...mapGetters("user", ["currentUser"]),
    ...mapGetters("general", ["likeList"]),
    ...mapGetters("timeline", ["timelines", "timelinesLoading"]),
    ...mapGetters("lastGreeting", ["lastGreetings", "lastGreetingsLoading"]),
    ...mapGetters("suggestedItems", ["suggestions", "selectedSuggestion"]),
    ...mapGetters("weeklyTales", ["personStories"]),
    showLikes() {
      return this.currentPackage.likes == "Yes";
    },
    showBookmarks() {
      return this.currentPackage.bookmarks == "Yes";
    },
    showImageAndVideoComments() {
      return this.currentPackage?.comments == "Yes";
    },
    showImageAndVideoInfo() {
      return this.currentPackage?.imageAndVideoInfo == "Yes";
    },
    showMediaBio() {
      return this.currentPackage?.biographyDescription;
    },
    showAddGreetingBtn() {
      return (
        ["Pro", "Free always - Premium", "Premium"].includes(
          this.personData.packageName
        ) ||
        this.personData.lastGreetings.length < this.currentPackage.lastGreetings
      );
    },
    showAddBioBtn() {
      return (
        ["Pro", "Free always - Premium", "Premium"].includes(
          this.personData.packageName
        ) || this.personData.timelines.length < this.currentPackage.biography
      );
    },
    showAddImageBtn() {
      return (
        this.personData.images.length <
        (this.currentPackage.images == "1k" ? 1000 : this.currentPackage.images)
      );
    },

    showAddVideoBtn() {
      return this.personData.videos.length < this.currentPackage.videos;
    },
    showAddDocumentBtn() {
      return this.personData.documents.length < this.currentPackage.documents;
    },
    showSuggestPhoto() {
      return this.currentPackage.suggestPhoto == "Yes";
    },
    countriesDropdown() {
      return helpers.countries().map((el) => el.text);
    },
    currentPackage() {
      var name =
        this.personData.packageName == "Free always - Premium"
          ? "Premium"
          : this.personData.packageName;
      return packagesList.packages.find((el) => el.name === name);
    },
    showPackage() {
      if (this.currentUser.id == this.personData.userId) {
        var deceasedPackageName =
          this.personData.packageName == "Free always - Premium"
            ? "Premium"
            : this.personData.packageName;

        var packagePicked = packagesList.packages.find(
          (el) => el.name === deceasedPackageName
        );

        packagePicked.images =
          packagePicked.images == 1000 ? "1k" : packagePicked.images;

        return packagePicked;
      }
      return null;
    },
    currentPersonVideoUrl() {
      return this.currentPersonVideo?.videoUrl || "";
    },
    imageCount() {
      return this.personImages.totalPages;
    },
    documentsCount() {
      return this.personDocuments.totalPages;
    },
    videoCount() {
      return this.personVideos.totalPages;
    },
    petArray() {
      var arr = [
        "FavoriteFood",
        "FavoriteDesert",
        "FavoriteDrink",
        "FavoriteToy",
      ];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    foodArray() {
      var arr = [
        "FavoriteBreakfast",
        "FavoriteLunch",
        "FavoriteDinner",
        "FavoriteSnacks",
        "FavoriteFood",
        "FavoriteMeat",
        "FavoritePizza",
        "FavoritePasta",
        "FavoriteVegetable",
        "FavoriteFruit",
        "FavoriteDessert",
        "FavoriteCake",
      ];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    drinkArray() {
      var arr = [
        "FavoriteDrink",
        "FavoriteWine",
        "FavoriteBeer",
        "FavoriteTea",
        "FavoriteCoffee",
      ];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    movieArray() {
      var arr = [
        "FavoriteMovie",
        "FavoriteMovieGenre",
        "FavoriteActor",
        "FavoriteActress",
        "FavoriteTvShow",
        "FavoriteCartoon",
        "FavoriteMarvelMovie",
      ];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    booksArray() {
      var arr = ["FavoriteBook", "FavoriteMaleWriter", "FavoriteFemaleWriter"];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    sportArray() {
      var arr = ["FavoriteSport", "FavoriteSportPlayer"];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    lifestyleArray() {
      var arr = [
        "FavoriteDance",
        "FavoriteCar",
        "FavoriteGame",
        "FavoriteHobby",
        "FavoriteColor",
        "FavoriteFlower",
      ];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    travelArray() {
      var arr = [
        "FavoriteTravelPlace",
        "FavoriteMuseum",
        "FavoriteWaterfall",
        "FavoriteBeach",
        "FavoriteLake",
        "FavoriteSea",
        "FavoriteOcean",
        "FavoriteIsland",
        "FavoriteMountain",
        "FavoriteRiver",
        "FavoriteCity",
        "FavoriteCountry",
      ];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    musicArray() {
      var arr = [
        "FavoriteBand",
        "FavoriteSong",
        "FavoriteMusicGenre",
        "FavoriteMaleSigner",
        "FavoriteFemaleSigner",
      ];
      return (
        this.personData?.favorites.filter((el) => arr.includes(el.type)) || []
      );
    },
    people() {
      var toReturn = this.followerList.map((el) => {
        return {
          name: el.userFullName,
          group: "Group 1",
          avatar: el.profileImageUrl || null,
        };
      });

      return toReturn;
    },
    qrCodeValue() {
      // Assuming your app is hosted at 'https://yourdomain.com'
      const baseUrl = "https://www.goodcasper.com";
      const route = this.$route.path;

      // Build the complete URL with route and parameters
      const completeUrl = `${baseUrl}${route}`;

      return completeUrl;
    },
    sharing() {
      return {
        url: this.shareableLink,
        title: "Good Casper",
        description: this.shareableDescription,
        quote: this.shareableQuote,
        hashtags: "GoodCasper, MemorialPlatform",
      };
    },
    lang() {
      return this.$store.state.langObj || {};
    },
    loadingBiographies() {
      return this.timelinesLoading;
    },
    biographies() {
      return this.timelines.map((el) => {
        var userId = this.currentUser.id;
        return {
          id: el.id,
          personId: el.personId,
          userId: userId,
          title: el.title,
          description: el.description,
          from: el.from ? moment(el.from).format("YYYY-MM-DD") : null,
          to: el.to ? moment(el.to).format("YYYY-MM-DD") : null,
          assets: el.assets?.filter((el) => el) || [],
        };
      });
    },
  },
  methods: {
    closeDialogShowOrderDigitalGifts() {
      this.dialogShowOrderDigitalGifts = false;
    },
    deleteProfile() {
      // todo add function to delete profile
      this.showDeleteProfileDialog = false;
      this.pickPackage = false;
      alert("add function to delete profile");
      this.$router.push("/MyMemories");
    },
    deleteProfileModal() {
      this.showDeleteProfileDialog = true;
    },
    closeDeleteProfileDialog() {
      this.showDeleteProfileDialog = false;
    },
    closePickPackage() {
      this.pickPackage = false;
    },
    closeReportCommentThread() {
      this.openReportCommentThreadModel = false;
    },
    closeReportComment() {
      this.openReportCommentModel = false;
    },
    closeReportVideo() {
      this.openReportVideoModel = false;
    },
    closeReportImage() {
      this.openReportImageModel = false;
    },
    closeReportProfile() {
      this.openReportProfileModel = false;
    },
    closeLastGreetingReport() {
      this.openReportGreetingModel = false;
    },
    closeLastGreetingsDialog() {
      this.openDeleteGreetingModel = false;
    },
    closeQrCodePopup() {
      this.showQrCodePopup = false;
    },
    closeShareSocialActionsPopup() {
      this.showShareSocialActionsPopup = false;
    },
    closeSuggestedImagesConfirmDialog() {
      this.suggestedImagesConfirmDialog = false;
    },
    closeDeleteItemDialog() {
      this.deleteDialog = false;
    },
    getCurrentLocation() {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.personData.graveLocationLat =
              position.coords.latitude.toFixed(6);
            this.personData.graveLocationLng =
              position.coords.longitude.toFixed(6);
          },
          (err) => {
            console.error("Error:", err.message);
          }
        );
      }
    },
    addMarker(lat, lng) {
      // Remove marker if already exists
      if (this.marker) {
        this.map.removeLayer(this.marker);
      }

      // Create new marker
      const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
      this.marker = L.marker([lat, lng]).on("click", () => {
        window.open(googleMapsUrl, "_blank"); // Open Google Maps in new tab
      });

      // Add popup with Google map link
      this.marker.bindPopup(`
        <div>
          <a href="${googleMapsUrl}" target="_blank" style="color: blue; text-decoration: underline;">
            Google Maps
          </a>
        </div>
      `);

      // Add marker on map
      this.marker.addTo(this.map);
      this.map.setView([lat, lng], 13);
    },
    startImageOrder() {
      this.$store
        .dispatch("images/getImagesOrder", this.$route.params.id)
        .then(() => {
          this.orderImages = true;
        });
    },
    startVideoOrder() {
      this.$store
        .dispatch("videos/getVideosOrder", this.$route.params.id)
        .then(() => {
          this.orderVideos = true;
        });
    },
    startDocumentOrder() {
      this.$store
        .dispatch("documents/getDocumentsOrder", this.$route.params.id)
        .then(() => {
          this.orderDocuments = true;
        });
    },
    triggerImageUpload() {
      this.$refs.imageUpload.$el.querySelector("input").click();
    },
    triggerVideoUpload() {
      this.$refs.videoUpload.$el.querySelector("input").click();
    },
    triggerDocumentUpload() {
      this.$refs.documentUpload.$el.querySelector("input").click();
    },
    saveOrderImages() {
      var order = this.imagesOrder.map((el, ind) => {
        return {
          imageId: el.id,
          order: this.imagesOrder.length - ind,
        };
      });
      this.$store
        .dispatch("images/saveImagesOrder", { images: order })
        .then(() => {
          this.cancelOrderImages();
          this.getPersonImages(true);
          this.getParsonMetricsOnly();
        });
    },
    cancelOrderImages() {
      this.$store.commit("images/setImageOrder", []);
      this.orderImages = false;
    },
    saveOrderVideos() {
      var order = this.videosOrder.map((el, ind) => {
        return {
          videoId: el.id,
          order: this.videosOrder.length - ind,
        };
      });
      this.$store
        .dispatch("videos/saveVideosOrder", { videos: order })
        .then(() => {
          this.cancelOrderVideos();
          this.getPersonVideos(true);
          this.getParsonMetricsOnly();
        });
    },
    cancelOrderVideos() {
      this.$store.commit("videos/setVideoOrder", []);
      this.orderVideos = false;
    },
    saveOrderDocuments() {
      var order = this.documentsOrder.map((el, ind) => {
        return {
          documentId: el.id,
          order: this.documentsOrder.length - ind,
        };
      });
      this.$store
        .dispatch("documents/saveDocumentsOrder", { videos: order })
        .then(() => {
          this.cancelOrderDocuments();
          this.getPersonDocuments(true);
          this.getParsonMetricsOnly();
        });
    },
    cancelOrderDocuments() {
      this.$store.commit("documents/setDocumentOrder", []);
      this.orderDocuments = false;
    },
    handleReorderImage(newItems) {
      this.$store.commit("images/setImageOrder", newItems);
    },
    handleReorderVideo(newItems) {
      this.$store.commit("videos/setVideoOrder", newItems);
    },
    handleReorderDocument(newItems) {
      this.$store.commit("documents/setDocumentOrder", newItems);
    },
    downloadQrCode(ref) {
      // Access the canvas element correctly
      const canvas = ref.qrcode.$el.querySelector("canvas");
      if (canvas) {
        const dataUrl = canvas.toDataURL("image/png");

        // Create a link element to download the image
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = this.personMetrics.isHuman
          ? `${this.personData.firstName}_${this.personData.lastName}_qr_code.png`
          : `${this.personData.name}_qr_code.png`;
        link.click();
      } else {
        console.error("QR code canvas not found");
      }
    },
    getDeceasedStories() {
      this.$store.dispatch(
        "weeklyTales/getDeceasedStories",
        this.$route.params.id
      );
    },
    showComments() {
      this.showComment = !this.showComment;
    },
    deleteItem() {
      if (this.deleteDialogType === "documents") {
        this.$store
          .dispatch("documents/deletePersonDocument", this.deleteDialogId)
          .then(() => {
            this.deleteDialog = false;
            this.deleteDialogId = null;
            this.deleteDialogType = null;
            this.getPersonDocuments(true);
          });
      } else if (this.deleteDialogType === "videos") {
        this.$store
          .dispatch("videos/deletePersonVideo", this.deleteDialogId)
          .then(() => {
            this.deleteDialog = false;
            this.deleteDialogId = null;
            this.deleteDialogType = null;
            this.getPersonVideos(true);
            this.getParsonMetricsOnly();
          });
      } else if (this.deleteDialogType === "images") {
        this.$store
          .dispatch("images/deletePersonImage", this.deleteDialogId)
          .then(() => {
            this.deleteDialog = false;
            this.deleteDialogId = null;
            this.deleteDialogType = null;
            this.getPersonImages(true);
            this.getParsonMetricsOnly();
          });
      }
    },
    closeSuggestedItems() {
      this.pickedImages = [];
      this.selectAllSuggestedImages = false;
      this.$store.commit("suggestedItems/setSelectedSuggestion", null);
    },
    getSuggestedImageByUser(sug) {
      this.$store.dispatch("suggestedItems/getSuggestedImageByUser", {
        deceasedId: this.$route.params.id,
        userId: sug.userId,
      });
    },
    getSuggestedItems() {
      if (this.currentUser.id === this.personData.userId) {
        this.$store.dispatch(
          "suggestedItems/getSuggestedImages",
          this.$route.params.id
        );
      }
    },
    deleteSuggestedImages() {
      var payload = {
        deceasedId: this.$route.params.id,
        suggestionIds: this.pickedImages,
      };
      this.$store
        .dispatch("suggestedItems/deleteSuggestedImages", payload)
        .then(() => {
          this.getSuggestedItems();
          this.pickedImages = [];
          this.selectAllSuggestedImages = false;
          this.suggestedImagesConfirmDialog = false;
          this.$store.commit("suggestedItems/setSelectedSuggestion", null);
        });
    },
    acceptSuggestedImages() {
      var payload = {
        deceasedId: this.$route.params.id,
        suggestionIds: this.pickedImages,
      };
      this.$store
        .dispatch("suggestedItems/acceptSuggestedImages", payload)
        .then(() => {
          this.getSuggestedItems();
          this.pickedImages = [];
          this.selectAllSuggestedImages = false;
          this.suggestedImagesConfirmDialog = false;
          this.getParsonMetricsOnly();
          this.$store.commit("suggestedItems/setSelectedSuggestion", null);
        });
    },
    toggleAll() {
      if (this.selectAllSuggestedImages) {
        this.pickedImages = this.selectedSuggestion.map(
          (el) => el.suggestionId
        );
      } else {
        this.pickedImages = [];
      }
    },
    openConfirmSuggestedDialog(type) {
      this.suggestedActionType = type;
      this.suggestedImagesConfirmDialog = true;
    },
    toggleImageSelect(id) {
      this.pickedImages.includes(id)
        ? (this.pickedImages = this.pickedImages.filter((el) => el !== id))
        : this.pickedImages.push(id);

      this.selectAllSuggestedImages =
        this.pickedImages.length === this.selectedSuggestion.length;
    },
    async customAction() {
      var files = this.files;
      if (files?.length) {
        this.$store.commit("loading", true);
        if (
          files.length + this.personData.images.length >
          this.currentPackage.images
        ) {
          this.$store.commit("toast", {
            message: this.lang.actions.maximumUpload,
            color: "red lighten-2",
          });

          this.$store.commit("loading", false);
          this.files = [];
          return;
        }

        let isAnyFileTooLarge = false;

        for (const file of files) {
          const fileSizeInMB = file.size / (1024 * 1024);

          if (fileSizeInMB >= 10) {
            isAnyFileTooLarge = true;
            break; // Exit loop once a file larger than 10 MB is found
          }
        }

        if (isAnyFileTooLarge) {
          this.$store.commit("toast", {
            message: this.lang.general.maximumImageSize,
            color: "red lighten-2",
          });

          this.$store.commit("loading", false);
          this.files = [];
          return;
        }

        var fd = new FormData();

        for (const file of files) {
          await new Promise((resolve, reject) => {
            new Compressor(file.file, {
              quality: 0.8,
              success: (compressedFile) => {
                fd.append("files", compressedFile, file.name);
                fd.append("fileType", 1);
                resolve();
              },
              error(err) {
                reject(err);
              },
            });
          });
        }

        this.$store
          .dispatch("uploadDeceasedSuggestionImages", {
            formData: fd,
            deceasedId: this.$route.params.id,
          })
          .then(() => {
            this.files = [];
            this.$store.commit("loading", false);
          });
      }
    },
    goToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    triggerFileUpload() {
      this.$refs.fileInput.$el.querySelector("input").click();
    },
    onProfileImgUpload(file) {
      this.$store.commit("loading", true);
      if (file) {
        var notValid = file.size / (1024 * 1024) >= 10; // 10mb allowed per image
        if (notValid) {
          this.$store.commit("toast", {
            message: this.lang.general.maximumImageSize,
            color: "red lighten-2",
          });
          this.$store.commit("loading", false);
          return;
        }
        new Compressor(file, {
          quality: 0.8,
          success: (compressedFile) => {
            var fd = new FormData();
            fd.append("deceasedId", this.$route.params.id); // Append additional data
            fd.append("file", compressedFile, file.name);
            fd.append("type", 1); // Example: 1 for Deceased, 2 for User

            this.$store
              .dispatch("uploadDeceasedProfileImage", fd)
              .then((response) => {
                this.getParsonMetricsOnly();
                this.newProfileImage = null;
                this.$store.commit("loading", false);
              });
          },
          error(err) {
            this.$store.commit("loading", false);
          },
        });
      }
    },
    getUserProfileImage(gender) {
      return helpers.getAvatarProfile(gender, this.personMetrics.isHuman);
    },
    closeDialogFollowPerson() {
      this.description = "";
      this.dialogFollow = false;
    },
    sendRequestModal() {
      this.dialogFollow = true;
    },
    followPerson(description) {
      var payload = {
        personId: this.$route.params.id,
        byUserId: this.currentUser.id,
        emails: [this.personMetrics.userMail],
        description: description,
      };
      this.$store
        .dispatch("person/followPerson", payload)
        .then(() => {
          this.getParsonMetrics();
          this.closeDialogFollowPerson();
        })
        .catch(() => {
          this.closeDialogFollowPerson();
        });
    },
    seePendingRequest() {
      this.$router.push("/PendingRequests");
    },
    closeFollowerList() {
      this.dialogFollowers = false;
    },
    isTypeOf(data) {
      return typeof data.item !== "object";
    },
    saveInfoDialog(type) {
      this.showInfoEdit = false;
      if (type == "image") {
        this.$store
          .dispatch("images/updateImageDetails", this.info)
          .then(() => {
            this.currentPersonImage.location = this.info.location;
            this.currentPersonImage.title = this.info.title;
            this.currentPersonImage.description = this.info.description;
            this.currentPersonImage.memoryDate = this.info.memoryDate;
            this.currentPersonImage.friends = this.info.friends;
            this.info = null;
          });
      } else {
        this.$store
          .dispatch("videos/updateVideoDetails", this.info)
          .then(() => {
            this.currentPersonVideo.location = this.info.location;
            this.currentPersonVideo.title = this.info.title;
            this.currentPersonVideo.description = this.info.description;
            this.currentPersonVideo.memoryDate = this.info.memoryDate;
            this.currentPersonVideo.friends = this.info.friends;
            this.info = null;
          });
      }
    },
    editInfo(item, type) {
      this.info = {
        location: item.location,
        title: item.title,
        description: item.description,
        memoryDate: item.memoryDate
          ? moment(item.memoryDate).format("YYYY-MM-DD")
          : null,
        friends: item.friends,
      };
      if (type == "video") {
        this.info.videoId = item.id;
      } else {
        this.info.imageId = item.id;
      }

      this.showInfoEdit = true;
    },
    remove(item) {
      const index = this.info.friends.indexOf(item.name);
      if (index >= 0) this.info.friends.splice(index, 1);
    },
    showInfoContainer() {
      this.showInfo = true;
    },
    closeInfoDialog() {
      this.showInfoEdit = false;
      this.showInfo = false;
    },
    closeEditInfoDialog() {
      this.showInfoEdit = false;
    },
    deleteComment() {
      var endpoint = "images/getPersonImageById";
      if (this.commentForDelete.state == "video") {
        endpoint = "videos/getPersonVideoById";
      }
      this.$store
        .dispatch("general/deleteComment", {
          id: this.commentForDelete.id,
          userId: this.currentUser.id,
        })
        .then(() => {
          this.$store.dispatch(endpoint, {
            personId: this.$route.params.id,
            entityId: this.$route.query.id,
          });
          this.threadList = null;
          this.closeDeleteCommentModel();
        });
    },
    closeDeleteCommentModel() {
      this.commentForDelete = null;
      this.openDeleteCommentModel = false;
    },
    deleteCommentDialog(comment, type, state) {
      this.commentForDelete = comment;
      this.commentForDelete.type = type;
      this.commentForDelete.state = state;
      this.openDeleteCommentModel = true;
    },
    closeEditComment() {
      this.editCommentId = null;
      this.imageComment = "";
      this.videoComment = "";
      this.imageCommentThread = "";
      this.videoCommentThread = "";
    },
    editComment(comment) {
      this.imageComment = comment.text;
      this.videoComment = comment.text;
      this.imageCommentThread = comment.text;
      this.videoCommentThread = comment.text;
      this.editCommentId = comment.id;
    },
    closeImageDialog() {
      this.dialog = false;
      this.closeInfoDetailsOverlay();
      this.resetDialogState();
      this.$router.push({ query: {} });
    },
    resetDialogState() {
      this.editCommentId = null;
      this.threadList = null;
      this.imageComment = "";
      this.imageCommentThread = "";
      this.videoComment = "";
      this.videoCommentThread = "";
      this.setBrowserTheme();
    },
    closeVideoDialog() {
      this.dialogVideo = false;
      this.closeInfoDetailsOverlay();
      this.resetDialogState();
      this.$router.push({ query: {} });
    },
    getUserInitials(name, lastName) {
      return helpers.getInitials(name, lastName);
    },
    getFullNameInitials(name) {
      return helpers.getFullNameInitials(name);
    },
    seeThreadsOverlay(threads) {
      this.threadList = threads;
    },
    closeThreadOverlay() {
      this.threadList = null;
    },
    closeInfoDetailsOverlay() {
      this.showInfo = null;
      this.showInfoEdit = null;
    },
    viewLikes(likes) {
      if (likes.length) {
        this.$store.dispatch(
          "general/viewLikes",
          likes.map((el) => el.userId)
        );
      }
    },
    closeLikeList() {
      this.$store.state.general.likeList = [];
    },
    entityLiked(likes) {
      return likes.find((el) => el.userId == this.currentUser.id)?.id || false;
    },
    shareContent(data, type) {
      const currentRoute = this.$route.path;
      var typeValue = 0;

      switch (type) {
        case "image":
          typeValue = 1;
          data = this.personData.images[data];
          break;
        case "video":
          typeValue = 2;
          data = this.personData.images[data];
          break;
        case "profile":
          typeValue = 0;
          data = data.id;
          break;
        default:
          break;
      }
      const currentParams = `id=${data}&type=${typeValue}`;

      this.shareableLink = this.createShareableLink(
        currentRoute,
        typeValue ? currentParams : ""
      );

      var fullName = this.personMetrics.isHuman
        ? `${this.personData.firstName} ${this.personData.lastName}`
        : `${this.personData.name}`;
      this.shareableDescription = fullName;
      this.shareableQuote = fullName;

      // Set the generated link in the component data
      this.showShareSocialActionsPopup = true;
    },
    createShareableLink(route, params) {
      const baseUrl = "https://www.goodcasper.com";

      // Ensure route starts with a slash
      const sanitizedRoute = route.startsWith("/") ? route : `/${route}`;

      // Handle params as either a string or an object
      const paramString =
        typeof params === "string"
          ? params
          : new URLSearchParams(params || {}).toString();

      // Construct the final URL
      const completeUrl = paramString
        ? `${baseUrl}${sanitizedRoute}?${paramString}`
        : `${baseUrl}${sanitizedRoute}`;

      return completeUrl;
    },
    uploadDeceasedProfileImage(fd) {
      this.$store.dispatch("person/uploadProfileImage", fd);
    },
    getPersonImages(resetPage = false) {
      if (resetPage) {
        this.imagePageIndex = 1;
      }
      this.$store.dispatch("images/getPersonImages", {
        deceasedId: this.$route.params.id,
        pageSize: this.imagePageSize,
        pageIndex: this.imagePageIndex,
      });
    },
    getPersonVideos(resetPage = false) {
      if (resetPage) {
        this.videoPageIndex = 1;
      }
      this.$store.dispatch("videos/getPersonVideos", {
        deceasedId: this.$route.params.id,
        pageSize: this.videoPageSize,
        pageIndex: this.videoPageIndex,
      });
    },
    getPersonDocuments(resetPage = false) {
      if (resetPage) {
        this.documentPageIndex = 1;
      }
      this.$store.dispatch("documents/getPersonDocuments", {
        deceasedId: this.$route.params.id,
        pageSize: this.documentPageSize,
        pageIndex: this.documentPageIndex,
      });
    },
    async onImageFileSelected(files) {
      var allowed =
        this.currentPackage.images == "1k" ? 1000 : this.currentPackage.images;
      if (files?.length) {
        if (files.length + this.personData.images.length > allowed) {
          this.$store.commit("loading", true);
          this.$store.commit("toast", {
            message: this.lang.profile.maximumUpload,
            color: "red lighten-2",
          });

          this.$store.commit("loading", false);
          return;
        }

        let isAnyFileTooLarge = false;

        for (const file of files) {
          const fileSizeInMB = file.size / (1024 * 1024);

          if (fileSizeInMB >= 10) {
            isAnyFileTooLarge = true;
            break; // Exit loop once a file larger than 10 MB is found
          }
        }

        if (isAnyFileTooLarge) {
          this.$store.commit("toast", {
            message: this.lang.general.maximumImageSize,
            color: "red lighten-2",
          });

          this.$store.commit("loading", false);
          return;
        }

        var fd = new FormData();

        for (const file of files) {
          await new Promise((resolve, reject) => {
            new Compressor(file, {
              quality: 0.8,
              success: (compressedFile) => {
                fd.append("files", compressedFile, file.name);
                resolve();
              },
              error(err) {
                reject(err);
              },
            });
          });
        }

        this.$store
          .dispatch("uploadDeceasedImages", {
            formData: fd,
            deceasedId: this.$route.params.id,
          })
          .then(() => {
            this.getParsonMetricsOnly();
            this.imagePageIndex = 1;
            this.$store.dispatch("images/getPersonImages", {
              deceasedId: this.$route.params.id,
              pageSize: this.imagePageSize,
              pageIndex: this.imagePageIndex,
            });
            this.newImages = null;
            this.$store.commit("loading", false);
          });
      }
    },
    onVideoFileSelected(file) {
      if (file) {
        this.$store.commit("loading", true);
        let fileTooLarge = file.size / (1024 * 1024) >= 100;

        if (fileTooLarge) {
          this.$store.commit("toast", {
            message: this.lang.general.maximumVideoSize,
            color: "red lighten-2",
          });
          this.$store.commit("loading", false);
          return;
        }

        var fd = new FormData();
        fd.append("files", file);

        this.$store
          .dispatch("uploadDeceasedVideos", {
            formData: fd,
            deceasedId: this.$route.params.id,
          })
          .then((response) => {
            this.$store.dispatch("videos/getPersonVideos", {
              deceasedId: this.$route.params.id,
              pageSize: this.videoPageSize,
              pageIndex: this.videoPageIndex,
            });
            this.getParsonMetricsOnly();
            this.newVideos = null;
            this.$store.commit("loading", false);
          });
      }
    },
    manageLike(type, data, id, onWhat, isThread) {
      // Video = 1,
      // Image = 2,
      // Comment = 3

      var endpoint = "";
      var subEndpoint = "";
      var subPayload = "";
      var stateType = "";
      var payload = null;

      if (this.entityLiked(data)) {
        endpoint = "general/deleteLike";
        payload = this.entityLiked(data);
      } else {
        endpoint = "general/addLike";
        payload = {
          userId: this.currentUser.id,
          entityId: id,
          type,
        };
      }

      if (["image", "imageComment", "imageCommentThread"].includes(onWhat)) {
        subEndpoint = "images/getPersonImageById";
        subPayload = {
          personId: this.$route.params.id,
          entityId: this.currentPersonImage.id,
        };
        stateType = "currentPersonImage";
      }

      if (["video", "videoComment", "videoCommentThread"].includes(onWhat)) {
        subEndpoint = "videos/getPersonVideoById";
        subPayload = {
          personId: this.$route.params.id,
          entityId: this.currentPersonVideo.id,
        };

        stateType = "currentPersonVideo";
      }

      this.$store.dispatch(endpoint, payload).then(() => {
        this.$store.dispatch(subEndpoint, subPayload).then(() => {
          if (isThread) {
            this.seeThreadsOverlay(
              this[stateType].comments.find((el) => el.id == isThread.entityId)
            );
          }
        });
      });
    },
    manageBookmark(data, type) {
      var endpoint = "";
      if (type == "Image") {
        endpoint = "images/getPersonImageById";
      } else {
        endpoint = "videos/getPersonVideoById";
      }
      if (data.bookmarkedByLoggedInUser) {
        this.$store
          .dispatch("general/deleteBookmark", {
            id: data.bookmarkedByLoggedInUser,
          })
          .then(() => {
            this.$store.dispatch(endpoint, {
              personId: this.$route.params.id,
              entityId: data.id,
            });
          });
      } else {
        var payload = {
          userID: this.currentUser.id,
          entityId: data.id,
          personId: data.personId,
          type,
        };
        this.$store.dispatch("general/addBookmark", payload).then(() => {
          this.$store.dispatch(endpoint, {
            personId: this.$route.params.id,
            entityId: data.id,
          });
        });
      }
    },
    addInviteMails() {
      if (this.inviteEmail.match(/\S+@\S+\.\S+/)) {
        this.inviteEmails.push(this.inviteEmail);
      }
      this.inviteEmail = "";
    },
    leaveCommentThreadOnImage() {
      if (!this.imageCommentThread) {
        return;
      }
      var endpoint = "general/insertComment";
      var payload = {
        userId: this.currentUser.id,
        entityId: this.threadList.id,
        text: this.imageCommentThread,
        reported: false,
        type: 3,
        dateOfCreate: new Date(),
      };
      if (this.editCommentId) {
        payload.id = this.editCommentId;
        endpoint = "general/updateComment";
      }
      this.$store.dispatch(endpoint, payload).then(() => {
        this.$store
          .dispatch("images/getPersonImageById", {
            personId: this.$route.params.id,
            entityId: this.personData.images[this.imageShowIndex],
          })
          .then(() => {
            this.seeThreadsOverlay(
              this["currentPersonImage"].comments.find(
                (el) => el.id == this.threadList.id
              )
            );
            this.closeEditComment();
          });
      });
    },
    leaveCommentThreadOnVideo() {
      if (!this.videoCommentThread) {
        return;
      }
      var endpoint = "general/insertComment";
      var payload = {
        userId: this.currentUser.id,
        entityId: this.threadList.id,
        text: this.videoCommentThread,
        reported: false,
        type: 3,
        dateOfCreate: new Date(),
      };
      if (this.editCommentId) {
        payload.id = this.editCommentId;
        endpoint = "general/updateComment";
      }
      this.$store.dispatch(endpoint, payload).then(() => {
        this.$store
          .dispatch("videos/getPersonVideoById", {
            personId: this.$route.params.id,
            entityId: this.personData.videos[this.videoShowIndex],
          })
          .then(() => {
            this.seeThreadsOverlay(
              this["currentPersonVideo"].comments.find(
                (el) => el.id == this.threadList.id
              )
            );
            this.closeEditComment();
          });
      });
    },
    leaveCommentOnImage() {
      if (!this.imageComment) {
        return;
      }
      var endpoint = "general/insertComment";
      var payload = {
        userId: this.currentUser.id,
        entityId: this.personData.images[this.imageShowIndex],
        text: this.imageComment,
        reported: false,
        type: 2,
        dateOfCreate: new Date(),
      };

      if (this.editCommentId) {
        payload.id = this.editCommentId;
        endpoint = "general/updateComment";
      }

      this.$store.dispatch(endpoint, payload).then(() => {
        this.$store.dispatch("images/getPersonImageById", {
          personId: this.$route.params.id,
          entityId: this.personData.images[this.imageShowIndex],
        });
        this.closeEditComment();
      });
    },
    leaveCommentOnVideo() {
      if (!this.videoComment) {
        return;
      }
      var endpoint = "general/insertComment";
      var payload = {
        userId: this.currentUser.id,
        entityId: this.personData.videos[this.videoShowIndex],
        text: this.videoComment,
        reported: false,
        type: 1,
        dateOfCreate: new Date(),
      };

      if (this.editCommentId) {
        payload.id = this.editCommentId;
        endpoint = "general/updateComment";
      }

      this.$store.dispatch(endpoint, payload).then(() => {
        this.$store.dispatch("videos/getPersonVideoById", {
          personId: this.$route.params.id,
          entityId: this.personData.videos[this.videoShowIndex],
        });
        this.closeEditComment();
      });
    },
    leftImage() {
      this.closeThreadOverlay();
      this.imageShowIndex = this.imageShowIndex - 1;
      this.closeInfoDetailsOverlay();
      this.emitImageShow(this.imageShowIndex);
    },
    leftVideo() {
      this.closeThreadOverlay();
      this.videoShowIndex = this.videoShowIndex - 1;
      this.closeInfoDetailsOverlay();
      this.emitVideoShow(this.videoShowIndex);
    },
    rightImage() {
      this.closeThreadOverlay();
      this.imageShowIndex = this.imageShowIndex + 1;
      this.closeInfoDetailsOverlay();
      this.emitImageShow(this.imageShowIndex);
    },
    rightVideo() {
      this.closeThreadOverlay();
      this.videoShowIndex = this.videoShowIndex + 1;
      this.closeInfoDetailsOverlay();
      this.emitVideoShow(this.videoShowIndex);
    },
    emitImageShow(index) {
      if (isNaN(index)) {
        index = this.personData.images.findIndex((el) => el == index);
      }
      this.closeThreadOverlay();
      this.imageShowIndex = index;
      this.dialog = true;
      var entityId = this.personData.images[index];
      this.$router.push({ query: { id: entityId, type: "1" } });
      this.currentPersonImage ? (this.currentPersonImage.imageUrl = null) : "";

      this.$store
        .dispatch("images/getPersonImageById", {
          personId: this.$route.params.id,
          entityId: entityId,
        })
        .then(() => {
          this.setBrowserTheme("#1c1e21");
        });
    },
    emitVideoShow(index) {
      if (isNaN(index)) {
        index = this.personData.videos.findIndex((el) => el == index);
      }

      this.closeThreadOverlay();
      this.videoShowIndex = index;
      this.dialogVideo = true;
      this.videoShowIndex = index;
      this.dialogVideo = true;
      var entityId = this.personData.videos[index];
      this.currentPersonVideo ? (this.currentPersonVideo.videoUrl = null) : "";

      this.$router.push({ query: { id: entityId, type: "2" } });

      this.$store
        .dispatch("videos/getPersonVideoById", {
          personId: this.$route.params.id,
          entityId: entityId,
        })
        .then(() => {
          this.setBrowserTheme("#1c1e21");
        });
    },
    showFollowers() {
      this.dialogFollowers = true;
    },
    setBrowserTheme(color = false) {
      if (!color) {
        color = "#3093a5";
        switch (this.currentUser?.theme) {
          case "no-theme":
          case "theme-default":
            color = "#3093a5";
            break;
          case "theme-black":
            color = "#000000";
            break;
          case "theme-blue-gray":
            color = "#607D8B";
            break;
          case "theme-blue":
            color = "#1E88E5";
            break;
          case "theme-cyan":
            color = "#00B8D4";
            break;
          case "theme-dark-red":
            color = "#D50000";
            break;
          case "theme-green":
            color = "#64DD17";
            break;
          case "theme-light-green":
            color = "#00C853";
            break;
          case "theme-light-brown":
            color = "#8D6E63";
            break;
          case "theme-lime-dark":
            color = "#9E9D24";
            break;
          case "theme-orange":
            color = "#F57C00";
            break;
          case "theme-pink":
            color = "#FF4081";
            break;
          case "theme-light-purple":
            color = "#E040FB";
            break;
          case "theme-purple":
            color = "#800080";
            break;
        }

        document
          .querySelector('meta[name="theme-color"]')
          ?.setAttribute("content", color);
      } else {
        document
          .querySelector('meta[name="theme-color"]')
          ?.setAttribute("content", color);
      }
    },
    getFollowers() {
      this.$store.dispatch("person/getFollowers", this.$route.params.id);
    },
    deleteImage(id) {
      this.deleteDialogType = "images";
      this.deleteDialog = true;
      this.deleteDialogId = id;
    },
    deleteVideo(id) {
      this.deleteDialogType = "videos";
      this.deleteDialog = true;
      this.deleteDialogId = id;
    },
    deletePersonDocument(id) {
      this.deleteDialogType = "documents";
      this.deleteDialog = true;
      this.deleteDialogId = id;
    },
    onDocumentFileSelected(files) {
      var allowed = this.currentPackage.documents;
      if (files?.length) {
        if (files.length + this.personData.documents.length > allowed) {
          this.$store.commit("loading", true);
          this.$store.commit("toast", {
            message: this.lang.profile.maximumUpload,
            color: "red lighten-2",
          });
          this.$store.commit("loading", false);
          return;
        }

        let isAnyFileTooLarge = false;

        for (const file of files) {
          const fileSizeInMB = file.size / (1024 * 1024);

          if (fileSizeInMB >= 50) {
            isAnyFileTooLarge = true;
            break; // Exit loop once a file larger than 50 MB is found
          }
        }

        if (isAnyFileTooLarge) {
          this.$store.commit("toast", {
            message: this.lang.general.maximumVideoSize,
            color: "red lighten-2",
          });
          this.$store.commit("loading", false);
          return;
        }

        var fd = new FormData();
        files.forEach((file) => {
          fd.append("files", file);
        });

        this.$store
          .dispatch("uploadDeceasedDocuments", {
            formData: fd,
            deceasedId: this.$route.params.id,
          })
          .then(() => {
            this.getPersonDocuments(true);
            this.newDocuments = null;
            this.$store.commit("loading", false);
          });
      }
    },
    deleteLastGreetingModal(lastGreeting) {
      this.currentGreeting = lastGreeting;
      this.openDeleteGreetingModel = true;
    },
    openDialogReportProfileModal() {
      this.reportReason = "";
      this.reportOther = "";
      this.openReportProfileModel = true;
    },
    openDialogReportImageModal(image) {
      this.reportReason = "";
      this.reportOther = "";
      this.currentImage = image;
      this.openReportImageModel = true;
    },
    openDialogReportVideoModal(video) {
      this.reportReason = "";
      this.reportOther = "";
      this.currentVideo = video;
      this.openReportVideoModel = true;
    },
    openDialogReportCommentModal(comment) {
      this.reportReason = "";
      this.reportOther = "";
      this.currentComment = comment;
      this.openReportCommentModel = true;
    },
    openDialogReportCommentThreadModal(commentThread) {
      this.reportReason = "";
      this.reportOther = "";
      this.currentCommentThread = commentThread;
      this.openReportCommentThreadModel = true;
    },
    openDialogLastGreetingReportModal(lastGreeting) {
      this.reportReason = "";
      this.reportOther = "";
      this.currentGreeting = lastGreeting;
      this.openReportGreetingModel = true;
    },
    addLastGreetingModal(lastGreeting) {
      this.currentGreeting = lastGreeting;
      this.lastGreetingNote = lastGreeting ? lastGreeting.note : "";
      this.lastGreetingModel = true;
    },
    reportProfile(reportReason, reportOther) {
      var payload = {
        userId: this.currentUser.id,
        entityId: this.$route.params.id,
        otherReason: reportOther,
        type: "Deceased",
        reason: reportReason,
      };

      this.$store
        .dispatch("reports/reportEntity", payload)
        .then(() => {
          this.openReportProfileModel = false;
        })
        .catch(() => {
          this.openReportProfileModel = false;
        });
    },
    reportLastGreeting(reportReason, reportOther) {
      var payload = {
        userId: this.currentUser.id,
        entityId: this.currentGreeting.id,
        otherReason: reportOther,
        type: "LastGreeting",
        reason: reportReason,
      };

      this.$store
        .dispatch("reports/reportEntity", payload)
        .then(() => {
          this.openReportGreetingModel = false;
        })
        .catch(() => {
          this.openReportGreetingModel = false;
        });
    },
    reportImage(reportReason, reportOther) {
      var payload = {
        userId: this.currentUser.id,
        entityId: this.currentImage,
        otherReason: reportOther,
        type: "Image",
        reason: reportReason,
      };
      this.$store
        .dispatch("reports/reportEntity", payload)
        .then(() => {
          this.openReportImageModel = false;
        })
        .catch(() => {
          this.openReportImageModel = false;
        });
    },
    reportVideo(reportReason, reportOther) {
      var payload = {
        userId: this.currentUser.id,
        entityId: this.currentVideo,
        otherReason: reportOther,
        type: "Video",
        reason: reportReason,
      };
      this.$store
        .dispatch("reports/reportEntity", payload)
        .then(() => {
          this.openReportVideoModel = false;
        })
        .catch(() => {
          this.openReportVideoModel = false;
        });
    },
    reportComment(reportReason, reportOther) {
      var payload = {
        userId: this.currentUser.id,
        entityId: this.currentComment.id,
        otherReason: reportOther,
        type: "Comment",
        reason: reportReason,
      };
      this.$store
        .dispatch("reports/reportEntity", payload)
        .then(() => {
          this.openReportCommentModel = false;
        })
        .catch(() => {
          this.openReportCommentModel = false;
        });
    },
    reportCommentThread(reportReason, reportOther) {
      var payload = {
        userId: this.currentUser.id,
        entityId: this.currentCommentThread.id,
        otherReason: reportOther,
        type: "CommentThread",
        reason: reportReason,
      };
      this.$store
        .dispatch("reports/reportEntity", payload)
        .then(() => {
          this.openReportCommentThreadModel = false;
        })
        .catch(() => {
          this.openReportCommentThreadModel = false;
        });
    },
    deleteLastGreeting() {
      this.$store
        .dispatch("lastGreeting/deleteLastGreeting", this.currentGreeting.id)
        .then(() => {
          this.getPerson();
          this.getLastGreetings();
          this.openDeleteGreetingModel = false;
          this.getParsonMetrics();
        })
        .catch(() => {
          this.openDeleteGreetingModel = false;
        });
    },
    addLastGreeting() {
      if (this.lastGreetingNote) {
        if (this.currentGreeting) {
          var obj = {
            Note: this.lastGreetingNote,
            currentUser: this.currentUser.id,
            Id: this.currentGreeting ? this.currentGreeting.id : null,
          };
          this.$store
            .dispatch("lastGreeting/editLastGreeting", obj)
            .then(() => {
              this.getLastGreetings();
              this.lastGreetingModel = false;
            })
            .catch(() => {
              this.lastGreetingModel = false;
            });
        } else {
          var obj = {
            Note: this.lastGreetingNote,
            ByUserId: this.currentUser.id,
            PersonId: this.personData.id,
          };
          this.$store
            .dispatch("lastGreeting/addLastGreeting", obj)
            .then(() => {
              this.getPerson();
              this.getLastGreetings();
              this.lastGreetingModel = false;
              this.getParsonMetrics();
            })
            .catch(() => {
              this.lastGreetingModel = false;
            });
        }
      } else {
        this.$store.commit("toast", {
          message: this.lang.general.fillAllFields,
          color: "red lighten-2",
        });
      }
    },
    updateProfile() {
      const requiredFields = this.personMetrics.isHuman
        ? ["firstName", "lastName", "dateOfBirth", "dateOfDeath"]
        : ["name", "dateOfBirth", "dateOfDeath"];

      for (const field of requiredFields) {
        if (!this.personData[field]) {
          this.$store.commit("toast", {
            message: this.lang.general.fillAllFields,
            color: "red lighten-2",
          });
          return;
        }
      }

      this.$store
        .dispatch(
          this.personMetrics.isHuman
            ? "person/updatePerson"
            : "person/updatePet",
          this.personData
        )
        .then(() => {
          if (
            this.personData.graveLocationLat &&
            this.personData.graveLocationLng
          ) {
            setTimeout(() => {
              this.initMap(
                this.personData.graveLocationLat,
                this.personData.graveLocationLng
              );
            }, 1000);
          }
          this.setEditMode(false);
          this.getParsonMetricsOnly();
        })
        .catch(() => {
          if (
            this.personData.graveLocationLat &&
            this.personData.graveLocationLng
          ) {
            setTimeout(() => {
              this.initMap(
                this.personData.graveLocationLat,
                this.personData.graveLocationLng
              );
            }, 1000);
          }
          this.setEditMode(false);
          this.getParsonMetricsOnly();
        });
    },
    saveDateOfBirthMenu(date) {
      this.$refs.dateOfBirthMenu.save(date);
    },
    setEditMode(mode) {
      this.editMode = mode;
      if (mode) {
        this.personData.dateOfBirth = moment(
          this.personData.dateOfBirth
        ).format("YYYY-MM-DD");
        this.personData.dateOfDeath = moment(
          this.personData.dateOfDeath
        ).format("YYYY-MM-DD");
        this.personDataClone = { ...this.personData };

        this.$nextTick(() => {
          const expansionPanel = this.$el.querySelector(".v-expansion-panel");
          if (expansionPanel) {
            expansionPanel.scrollIntoView({ behavior: "smooth" });
            this.activePanel = 0;
            this.activePanelFavorites = 0;
          }
        });
      }
    },
    cancelEditMode() {
      this.$store.state.person.personData = { ...this.personDataClone };
      this.setEditMode(false);
      setTimeout(() => {
        this.initMap(
          this.personData.graveLocationLat,
          this.personData.graveLocationLng
        );
      }, 1000);
    },
    closeDialogInvite() {
      this.dialogInvite = false;
      this.inviteEmail = "";
      this.inviteDescription = "";
      this.inviteEmails = [];
    },
    inviteUser() {
      if (this.inviteDescription && this.inviteEmails.length) {
        var payload = {
          personId: this.$route.params.id,
          byUserId: this.currentUser.id,
          emails: this.inviteEmails,
          description: this.inviteDescription,
        };

        this.$store
          .dispatch("person/followPerson", payload)
          .then(() => {
            this.closeDialogInvite();
          })
          .catch(() => {
            this.closeDialogInvite();
          });
      } else {
        this.$store.commit("toast", {
          message: this.lang.general.fillAllFields,
          color: "red lighten-2",
        });
      }
    },
    getBirthToDeathDate(birthDate, deathDate) {
      return `${moment(birthDate).format("DD/MM/YYYY")} - ${moment(
        deathDate
      ).format("DD/MM/YYYY")}`;
    },
    getDate(date) {
      return moment(new Date(date)).format("lll");
    },
    getDateShort(date) {
      return moment(new Date(date)).format("MMM Do") || "-";
    },
    getPersonAge(birthDate, deathDate) {
      const dateOfBirth = moment(birthDate);
      const dateOfDeath = moment(deathDate);

      const age = dateOfDeath.diff(dateOfBirth, "years");

      return age;
    },
    addTimeline(bio) {
      delete bio.id;
      bio.from = bio.from ? new Date(`${bio.from}`).toISOString() : null;
      bio.to = bio.to ? new Date(`${bio.to}`).toISOString() : null;
      bio.personId = this.$route.params.id;
      bio.dateOfCreate = new Date();
      bio.currentUser = this.currentUser.id;
      this.$store.dispatch("timeline/addTimeline", bio).then(() => {
        this.getTimelines();
      });
    },
    editTimeline(bio) {
      bio.from = bio.from ? new Date(`${bio.from}`).toISOString() : null;
      bio.to = bio.to ? new Date(`${bio.to}`).toISOString() : null;
      bio.personId = this.$route.params.id;
      bio.currentUser = this.currentUser.id;
      bio.assets.map((el) => {
        el.timelineId = bio.id;
        return el;
      });
      this.$store.dispatch("timeline/editTimeline", bio).then(() => {
        this.getTimelines();
      });
    },
    deleteTimeline(bioId) {
      this.$store.dispatch("timeline/deleteTimeline", bioId).then(() => {
        this.getTimelines();
      });
    },
    getPerson() {
      this.$store.dispatch("person/getPerson", {
        personId: this.$route.params.id,
        userId: this.currentUser.id,
        isHuman: this.personMetrics.isHuman,
      });
    },
    getPersonImageById(entityId) {
      this.$store.dispatch("images/getPersonImageById", {
        personId: this.$route.params.id,
        entityId,
      });
    },
    getLastGreetings() {
      this.$store.dispatch(
        "lastGreeting/getLastGreetings",
        this.$route.params.id
      );
    },
    getTimelines() {
      this.$store.dispatch(
        "timeline/getTimelineByPersonId",
        this.$route.params.id
      );
    },
    getParsonMetricsOnly() {
      this.$store
        .dispatch("person/getParsonMetrics", this.$route.params.id)
        .then(() => {
          if (this.personMetrics.isLoggedUserOwnerOrFollower) {
            this.getLastGreetings();
            this.$store.dispatch("person/getPerson", {
              personId: this.$route.params.id,
              userId: this.currentUser.id,
              isHuman: this.personMetrics.isHuman,
            });
          }
        });
    },
    getParsonMetrics() {
      this.$store
        .dispatch("person/getParsonMetrics", this.$route.params.id)
        .then(() => {
          if (this.personMetrics.isLoggedUserOwnerOrFollower) {
            this.getLastGreetings();
            this.$store
              .dispatch("person/getPerson", {
                personId: this.$route.params.id,
                userId: this.currentUser.id,
                isHuman: this.personMetrics.isHuman,
              })
              .then(() => {
                var sharedEntityId = this.$route.query.id;
                var sharedEntityType = this.$route.query.type;
                if (sharedEntityId && sharedEntityType) {
                  if (sharedEntityType == 1) {
                    this.tabSelected = 2; // image
                    this.emitImageShow(sharedEntityId);
                  } else if (sharedEntityType == 2) {
                    this.tabSelected = 3; // video
                    this.emitVideoShow(sharedEntityId);
                  }
                } else if (sharedEntityType == 5) {
                  this.tabSelected = 5; // suggestions
                }

                this.$store.commit("suggestedItems/setSuggestions", []);
                this.getSuggestedItems();
                if (this.personMetrics.isLoggedUserOwnerOrFollower) {
                  this.getDeceasedStories();
                }
              });
          }
        });
    },
    initMap(lat, lng) {
      // Init map
      this.map = L.map("map", {
        scrollWheelZoom: false,
      }).setView([lat, lng], 13);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(this.map);

      this.addMarker(lat, lng);
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollHandler);
  },
  mounted() {
    document.title = "Good Casper - Profile";
    this.scrollHandler = () => {
      const goTopButton = document.querySelector(".go-top");
      if (goTopButton) {
        if (window.scrollY > 500) {
          goTopButton.classList.add("visible");
        } else {
          goTopButton.classList.remove("visible");
        }
      }
    };

    window.addEventListener("scroll", this.scrollHandler);

    this.getParsonMetrics();
    this.getFollowers();
  },
  watch: {
    useCurrentLocation(val) {
      if (val) {
        this.getCurrentLocation();
      } else {
        this.personData.graveLocationLat = "";
        this.personData.graveLocationLng = "";
      }
    },
    togglePanel(val) {
      if (val) {
        if (
          this.personData.graveLocationLat &&
          this.personData.graveLocationLng
        ) {
          setTimeout(() => {
            this.initMap(
              this.personData.graveLocationLat,
              this.personData.graveLocationLng
            );
          }, 1000);
        }
      }
    },
    files(val) {
      if (val.length) {
        this.customAction();
      }
    },
    tabSelected(val) {
      if (!this.personMetrics.isLoggedUserOwnerOrFollower) {
        return;
      }
      if (val == 0) {
        this.getLastGreetings();
      } else if (val == 1) {
        this.getTimelines();
      } else if (val == 2) {
        this.getPersonImages(true);
      } else if (val == 3) {
        this.getPersonVideos(true);
      } else if (val == 4) {
        this.getPersonDocuments(true);
      } else if (val == 5) {
        this.$store.commit("suggestedItems/setSelectedSuggestion", null);
        this.getSuggestedItems();
      }
    },
  },
};
</script>
  
  <style lang="scss">
.v-expansion-panel-content__wrap {
  @media (max-width: 600px) {
    padding: 0 !important;
  }
}
.v-file-input.v-text-field--filled:not(.v-text-field--single-line)
  .v-file-input__text {
  padding-top: 0;
}

.v-slide-group:not(.v-slide-group--has-affixes) > .v-slide-group__prev,
.v-slide-group:not(.v-slide-group--has-affixes) > .v-slide-group__next {
  display: none !important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none;
  background: rgba(0, 0, 0, 0.06) !important;
}
</style>
  <style lang="scss" scoped>
.px-0-mobile {
  @media screen and (max-width: 768px) {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

.text-shadow {
  text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
}

.my-comment.input-group {
  display: flex;
  flex-direction: row;
  gap: 0rem;
}

.my-comment.input-group label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #4a5568;
}

.my-comment.input-group input {
  padding: 0.625rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  transition: all 0.2s ease;
  background-color: #f8fafc;
  color: #334155;
  @media screen and (max-width: 768px) {
    padding: 0.5rem;
  }
}

.my-comment.input-group input::placeholder {
  color: #94a3b8;
}

.my-comment.input-group input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  background-color: #fff;
}

.my-comment.input-group textarea {
  padding: 0.625rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  transition: all 0.2s ease;
  background-color: #f8fafc;
  color: #334155;
  width: 100%;
  resize: none; /* Disable resizing */
  overflow: auto; /* Ensure scrollbars appear if needed */
}

.my-comment.input-group textarea::placeholder {
  color: #94a3b8;
}

.my-comment.input-group textarea:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  background-color: #fff;
}

@media screen and (max-width: 768px) {
  .my-comment.input-group textarea {
    padding: 0.5rem;
  }
}

#mt-0 {
  margin-top: 0 !important;
}
.no-gutters.mt-0.row {
  margin-top: 0 !important;
}
.show-mobile {
  display: none;
}

@media (max-width: 600px) {
  .show-mobile {
    display: block;
  }
  .comment-container {
    display: none;
    &.show {
      display: block;
    }
  }
  .comments {
    position: fixed;
    inset: 0;
    top: 0;
    bottom: 140px;
    z-index: 6;
    &.pt-6 {
      padding-top: 35px !important;
    }
  }
  .comment-x {
    position: fixed;
    top: 0;
    right: 0;
    background: transparent;
    display: flex;
    justify-content: flex-end;
    z-index: 999;
    * {
      cursor: pointer;
      padding: 5px 10px;
    }
  }
  .pt-0-mobile {
    padding-top: 0 !important;
  }
}

.go-back {
  cursor: pointer;
  border: 1px solid #ccc;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 2px;
  margin-right: 10px;
}
.image-checked {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  border: 1px solid #fff;
  position: absolute;
  bottom: 5px;
  left: 15px;
  z-index: 99;
  color: #fff;
}
.click-to-select {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  bottom: 0px;
  left: 11px;
  z-index: 99;
  color: #fff;
  padding: 8px 8px;
  display: block;
  width: calc(100% - 11px);
  text-align: center;
}
.suggestions-count {
  cursor: pointer;
  background: red;
  color: #fff;
  font-size: 8px;
  border-radius: 50%;
  width: 15px;
  aspect-ratio: 1;
  position: absolute;
  top: 6px;
  left: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.suggested-container {
  cursor: pointer;
  box-shadow: 0px 0px 0px 1px rgb(0 0 0 / 10%);
  padding: 10px 0 10px 5px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  .suggested-content {
    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
    }
  }
  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    * {
      margin-bottom: 0;
    }
  }
  > div:nth-child(1) {
    width: 55px;
    justify-content: flex-start;
  }
  > div:nth-child(2) {
    width: calc(100% - 165px);
    flex-direction: column;
    align-items: flex-start;
  }
  > div:nth-child(3) {
    width: 70px;
    flex-direction: column;
    align-items: flex-end;
    padding-right: 10px;
  }
  > div:nth-child(4) {
    width: 40px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-left: 1px solid #ccc;
  }
}
.upload-files-container {
  margin: auto;
  border: 2px dotted #ccc;
  text-align: center;
  border-radius: 12px;
  height: 75vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .file-uploads {
    width: 100%;
    height: 100%;
    padding-top: 80px;
    padding-bottom: 80px;
  }
  img {
    width: 200px;
  }
  * {
    cursor: pointer;
  }
}
.go-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 10px;
  border-radius: 50%;
  z-index: 9;
  background: #000;
  cursor: pointer;
  display: none;
  &.visible {
    display: block;
  }
  i {
    color: #fff;
  }
  @media screen and (max-width: 600px) {
    bottom: 60px;
  }
}
.no-shadow {
  box-shadow: none !important;
}
.info-title {
  color: #636363;
}
.info-text {
  color: #636363;
}
.show-info-relative {
  position: relative;
  .show-info-container {
    position: absolute;
    top: 50px;
    right: 0;
    min-width: 350px;
    height: auto;
    border-radius: 4px;
    background: #fff;
    z-index: 50;
    .edit-dialog-info {
      position: absolute;
      top: 5px;
      left: 5px;
      color: #000;
      padding: 15px;
      cursor: pointer;
    }
    .close-dialog-info {
      position: absolute;
      top: 5px;
      right: 5px;
      color: #000;
      padding: 15px;
      cursor: pointer;
      text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
    }
  }
}
.main-comment {
  background: #f6f6f6;
  width: 100%;
  padding: 12px 5px 0px 0px;
  border-radius: 8px;
  margin-bottom: 15px;
}
.v-window-item--active {
  min-height: 80vh;
}
.v-expansion-panel::before {
  box-shadow: 0px 0px 0px 1px rgb(0 0 0 / 10%);
}
.image-container {
  position: relative;
  background: #1c1e21;
  min-height: calc(100vh);
  display: flex;
  justify-content: center;
  align-items: center;
  .v-image,
  img,
  video {
    max-width: 100vw;
    max-height: calc(100vh - 10px);
    margin: auto auto;
  }
  .action-dialog {
    position: absolute;
    top: 0;
    right: 0;
    color: #fff;
    padding: 15px;
    z-index: 5;
    button {
      text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
    }
    .show-info-relative {
      button {
        text-shadow: none;
      }
    }
  }
  .close-dialog {
    position: absolute;
    top: 0;
    left: 0;
    color: #fff;
    padding: 15px;
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
    &:hover {
      background: rgb(27 27 27 / 80%);
    }
  }
  .next-image {
    position: absolute;
    top: 49%;
    right: 8px;
    z-index: 5;
    color: #fff;
    padding: 15px 15px;
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
    &:hover {
      background: rgb(27 27 27 / 80%);
    }
    &::after {
      background: transparent !important;
    }
  }
  .back-image {
    position: absolute;
    top: 49%;
    left: 0;
    z-index: 5;
    color: #fff;
    padding: 15px 15px;
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
    &:hover {
      background: rgb(27 27 27 / 80%);
    }
    &::after {
      background: transparent !important;
    }
  }
}
.comment-container {
  background: #fff;
  min-height: calc(100vh - 64px);
  position: relative;
  padding-left: 10px;
  padding-right: 10px;
  .comment-item {
    border-bottom: 1px solid rgb(236, 236, 236);
    padding-bottom: 2px;
    &:last-child {
      border-bottom: none;
    }
  }
  .comments {
    padding-top: 12px;
    max-height: calc(100vh - 140px);
    background: #fff;
    overflow-y: scroll;
    .v-avatar {
      align-self: flex-start;
    }
    p {
      font-size: 12px;
      margin-bottom: 12px;
      color: #636363;
    }
    .caption-1 {
      font-size: 10px !important;
      color: #868686;
    }
  }
  .my-comment {
    flex: 0 0 24.5%;
    max-width: 24.5%;
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    background: #fff;
    padding-top: 12px;
    padding-bottom: 12px;
    bottom: 0;
    width: 100%;
    .v-text-field__details {
      display: none;
    }
  }
}
.edit-pen {
  cursor: pointer;
  position: absolute;
  right: 20px;
}
.qr-code {
  cursor: pointer;
  position: absolute;
  left: 20px;
  top: 60px;
}
.package-info {
  cursor: pointer;
  position: absolute;
  left: 20px;
  top: 105px;
}
.share-social-profile {
  cursor: pointer;
  position: absolute;
  left: 20px;
}
.report-pen {
  cursor: pointer;
  position: absolute;
  right: 20px;
  color: #b4b4b4;
  &:hover {
    color: #b71c1c;
  }
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  height: 100%;
}
.rel {
  position: relative;
  width: 180px;
  .input-image-container {
    border-width: 5px;
    border-style: solid;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    display: flex;
    width: 180px;
    height: 180px;
    background: transparent;
    justify-content: center;
    overflow: hidden;
    cursor: pointer;
    .camera-container {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      padding-top: 6px;
      background-color: rgba(0, 0, 0, 0.5);
      width: 170px;
      height: 90px;
      position: absolute;
      bottom: -55px;
      border-bottom-left-radius: 90px; /* 50% of parent width */
      border-bottom-right-radius: 90px; /* 50% of parent width */
      * {
        color: #fff;
      }
    }
  }
  .v-input {
    flex: 0 0 100%;
    margin: 0;
    padding: 5px;
  }
}
.user-profile-image {
  width: 150px;
  border-radius: 50%;
}
.column-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.profile-stats {
  flex-wrap: wrap;
  display: flex;
  justify-content: flex-end;
  section {
    width: 100%;
  }
  > div {
    flex: 0 0 25%;
    width: 25%;
    &.full-width {
      width: 100%;
      flex: 0 0 100%;
      > .with-radius {
        width: 180px;
      }
    }
    .v-divider {
      width: 50%;
      margin: auto;
    }
  }
  .full-row {
    flex: 0 0 100%;
  }
  &.edit-mode {
    > div {
      flex: 0 0 33.33%;
      width: 33.33%;
    }
    .full-row {
      flex: 0 0 100%;
    }
  }
  > div.action-form {
    flex: 0 0 100%;
    width: 100%;
    margin-top: 10px;
    position: fixed;
    top: -10px;
    left: 0;
    right: 0;
    z-index: 10;
    background: #fff;
    box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 10%);
    padding: 10px;
    @media (max-width: 600px) {
      top: 40px;
    }
  }
  p {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-size: 14px;
    color: #636363;
    font-weight: 600;
  }
  span.overline {
    color: #c1bfbf;
    font-size: 10px !important;
  }
  &--user {
    justify-content: space-evenly;
    margin-top: 25px;
    width: 100%;
    > div {
      flex: 0 0 33.33%;
      width: 33.33%;
    }
    .display-1 {
      font-size: 22px !important;
    }
    span.overline {
      margin-top: -10px;
      display: block;
    }
  }
}

@media only screen and (max-width: 1050px) {
  .profile-stats {
    justify-content: center;
    > div {
      flex: 0 0 33.33%;
      width: 33.33%;
      .v-divider {
        width: 70%;
        margin: auto;
      }
    }
    p {
      font-size: 16px;
    }
    span.overline {
      font-size: 10px !important;
    }
    &--user {
      margin-top: 25px;
      > div {
        flex: 0 0 33.33%;
        width: 33.33%;
      }
      .display-1 {
        font-size: 22px !important;
      }
      span.overline {
        margin-top: -10px;
      }
    }
  }
}
@media only screen and (max-width: 960px) {
  .image-container {
    .v-image {
      max-width: 80vw;
      max-height: 70vh;
      margin: auto auto;
    }
  }
  .comment-container {
    .my-comment {
      flex: 0 0 100%;
      max-width: 100%;
      bottom: 1px;
    }
  }
}
@media only screen and (max-width: 750px) {
  .profile-stats {
    justify-content: center;
    > div {
      flex: 0 0 50%;
      width: 50%;
      .v-divider {
        width: 80%;
        margin: auto;
      }
    }
    p {
      font-size: 13px;
    }
    span.overline {
      font-size: 9px !important;
    }

    &--user {
      margin-top: 25px;
      > div {
        flex: 0 0 33.33%;
        width: 33.33%;
      }
      .display-1 {
        font-size: 18px !important;
      }
      span.overline {
        margin-top: -10px;
      }
    }
    &.edit-mode {
      margin-top: 25px;
      > div {
        flex: 0 0 100% !important;
        width: 100% !important;
      }
      .display-1 {
        font-size: 18px !important;
      }
      span.overline {
        margin-top: -10px;
      }
    }
  }
}

@media only screen and (max-width: 600px) {
  .no-padding-mobile {
    > .col-12 {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}
</style>